import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
  /** Represents untyped JSON */
  JSON: { input: any; output: any }
  Upload: { input: any; output: any }
}

/** History log entry for activities done by all actors in the platform */
export type Activity = {
  __typename?: "Activity"
  /** Time when the activity was performed */
  createdAt: Scalars["ISO8601DateTime"]["output"]
  /** User ID */
  id: Scalars["ID"]["output"]
  /** Activity key */
  key: Scalars["String"]["output"]
  /** User who performed the activity */
  owner?: Maybe<ActivityOwnerInterface>
  /** Parameters of the activity (e.g. changes) */
  parameters?: Maybe<Scalars["JSON"]["output"]>
  /** Resource associated with the activity */
  resource?: Maybe<ActivityResourceInterface>
}

/** ActivityCollection type */
export type ActivityCollection = {
  __typename?: "ActivityCollection"
  /** A collection of paginated ActivityCollection */
  collection: Array<Activity>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** The connection type for Activity. */
export type ActivityConnection = {
  __typename?: "ActivityConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Activity>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** Total count of items in all pages. */
  totalCount: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ActivityEdge = {
  __typename?: "ActivityEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<Activity>
}

/** Owner of the activity */
export type ActivityOwnerInterface = {
  /** ID of the activity owner */
  id: Scalars["ID"]["output"]
  /** Type of the activity owner */
  type?: Maybe<Scalars["String"]["output"]>
}

/** Resource associated with the activity (trackable) */
export type ActivityResourceInterface = {
  /** ID of the resource */
  id: Scalars["ID"]["output"]
  /** Name of the resource (if applicable) */
  name?: Maybe<Scalars["String"]["output"]>
}

/** Application configuration exposed to the frontend */
export type AppConfig = {
  __typename?: "AppConfig"
  /** Google Maps JavaScript API key */
  googleMapsApiKey?: Maybe<Scalars["String"]["output"]>
}

/** Type of associated resource for an image */
export enum Associated {
  /** User resource */
  User = "user",
  /** Venue resource */
  Venue = "venue",
}

/** Available booking policy tile kinds */
export enum BookingPolicyTile {
  /** Cancellation */
  Cancellation = "cancellation",
  /** Group reservations */
  GroupReservations = "group_reservations",
  /** Running late */
  RunningLate = "running_late",
  /** Time limit */
  TimeLimit = "time_limit",
}

/** The business, a top-level entity in the system that owns venues and users */
export type Business = {
  __typename?: "Business"
  /** Customer of the business */
  customer?: Maybe<Customer>
  /** Contacts of the customers of the business */
  customerContacts: CustomerContactCollection
  /** Notes made by staff about customers */
  customerNotes?: Maybe<CustomerNoteCollection>
  /** Customers of the business */
  customers: CustomerCollection
  /** ID of the business */
  id: Scalars["ID"]["output"]
  /** Name of the business */
  name: Scalars["String"]["output"]
  /** Users that belong to the business */
  users: UserCollection
  /** Venues that belong to the business */
  venues: Array<Venue>
}

/** The business, a top-level entity in the system that owns venues and users */
export type BusinessCustomerArgs = {
  customerContactId?: InputMaybe<Scalars["ID"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

/** The business, a top-level entity in the system that owns venues and users */
export type BusinessCustomerContactsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
  searchField?: InputMaybe<Scalars["String"]["input"]>
  sort?: InputMaybe<CustomerContactSort>
  sortDirection?: InputMaybe<SortDirection>
}

/** The business, a top-level entity in the system that owns venues and users */
export type BusinessCustomerNotesArgs = {
  customerId: Scalars["ID"]["input"]
  order?: InputMaybe<CustomerNoteOrder>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

/** The business, a top-level entity in the system that owns venues and users */
export type BusinessCustomersArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** The business, a top-level entity in the system that owns venues and users */
export type BusinessUsersArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: "CollectionMetadata"
  /** Current Page of loaded data */
  currentPage: Scalars["Int"]["output"]
  /** The number of items per page */
  limitValue: Scalars["Int"]["output"]
  /** The total number of items to be paginated */
  totalCount: Scalars["Int"]["output"]
  /** The total number of pages in the pagination */
  totalPages: Scalars["Int"]["output"]
}

/** A generic error type for mutations */
export type CompleteOauthSignupError = {
  __typename?: "CompleteOauthSignupError"
  /** A machine-friendly code for the error */
  code: CompleteOauthSignupErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum CompleteOauthSignupErrorEnum {
  /** There was a problem while completing the signup */
  Generic = "GENERIC",
  /** No OAuth data found in session */
  NoOauthData = "NO_OAUTH_DATA",
  /** You are not authorized to complete this signup */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid signup data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of CompleteOauthSignup. */
export type CompleteOauthSignupPayload = {
  __typename?: "CompleteOauthSignupPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<CompleteOauthSignupError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The created user */
  user?: Maybe<CurrentUser>
}

/** Country type */
export enum Country {
  /** Poland */
  Poland = "POLAND",
}

/** A generic error type for mutations */
export type CreateAccountError = {
  __typename?: "CreateAccountError"
  /** A machine-friendly code for the error */
  code: CreateAccountErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum CreateAccountErrorEnum {
  /** There was a problem while creating the account */
  Generic = "GENERIC",
  /** You are not authorized to create accounts */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid account data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of CreateAccount. */
export type CreateAccountPayload = {
  __typename?: "CreateAccountPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<CreateAccountError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type CreateCustomerNoteError = {
  __typename?: "CreateCustomerNoteError"
  /** A machine-friendly code for the error */
  code: CreateCustomerNoteErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum CreateCustomerNoteErrorEnum {
  /** There was a problem while creating the customer note */
  Generic = "GENERIC",
  /** The customer was not found */
  NotFound = "NOT_FOUND",
}

/** Autogenerated return type of CreateCustomerNote. */
export type CreateCustomerNotePayload = {
  __typename?: "CreateCustomerNotePayload"
  /** The created customer note */
  customerNote?: Maybe<CustomerNote>
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<CreateCustomerNoteError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type CreateReservationError = {
  __typename?: "CreateReservationError"
  /** A machine-friendly code for the error */
  code: CreateReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum CreateReservationErrorEnum {
  /** There was a problem while creating the reservation */
  Generic = "GENERIC",
}

/** A generic error type for mutations */
export type CreateReservationNoteError = {
  __typename?: "CreateReservationNoteError"
  /** A machine-friendly code for the error */
  code: CreateReservationNoteErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum CreateReservationNoteErrorEnum {
  /** There was a problem while creating the reservation note */
  Generic = "GENERIC",
  /** The reservation was not found */
  NotFound = "NOT_FOUND",
}

/** Autogenerated return type of CreateReservationNote. */
export type CreateReservationNotePayload = {
  __typename?: "CreateReservationNotePayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<CreateReservationNoteError>>
  /** The created reservation note */
  reservationNote?: Maybe<ReservationNote>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** Autogenerated return type of CreateReservation. */
export type CreateReservationPayload = {
  __typename?: "CreateReservationPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<CreateReservationError>>
  /** The created reservations */
  reservations?: Maybe<Array<Reservation>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: "CreateUserPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UsersCreateUserError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The created user */
  user?: Maybe<User>
}

/** A generic error type for mutations */
export type CreateVenueError = {
  __typename?: "CreateVenueError"
  /** A machine-friendly code for the error */
  code: CreateVenueErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum CreateVenueErrorEnum {
  /** There was a problem while creating the venue */
  Generic = "GENERIC",
  /** You are not authorized to create venues */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid venue data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of CreateVenue. */
export type CreateVenuePayload = {
  __typename?: "CreateVenuePayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<CreateVenueError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The created venue */
  venue?: Maybe<Venue>
}

/** Current User */
export type CurrentUser = {
  __typename?: "CurrentUser"
  /** Avatar image of the user */
  avatar?: Maybe<Image>
  /** Avatar URL of the user (uses uploaded avatar or falls back to Gravatar) */
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  /** User email */
  email: Scalars["String"]["output"]
  /** First name of the user */
  firstName?: Maybe<Scalars["String"]["output"]>
  /** User ID */
  id: Scalars["ID"]["output"]
  /** Additional info about the user */
  info?: Maybe<UserInfo>
  /** Last name of the user */
  lastName?: Maybe<Scalars["String"]["output"]>
  /** Full name of the user */
  name: Scalars["String"]["output"]
  /** Roles assigned to the user */
  roles: Array<UserRole>
}

/** Current User */
export type CurrentUserRolesArgs = {
  venueSlug?: InputMaybe<Scalars["String"]["input"]>
}

/** A customer of a business that may reserve tables in more than one venue */
export type Customer = ActivityOwnerInterface &
  ActivityResourceInterface & {
    __typename?: "Customer"
    /** History log of the reservation */
    activities: ActivityConnection
    /** Business that the person is a customer of */
    business: Business
    /** Contact details of the customer */
    customerContacts: Array<CustomerContact>
    /** ID of the customer */
    id: Scalars["ID"]["output"]
    /** Latest known customer locale */
    locale?: Maybe<Scalars["String"]["output"]>
    /** Name of the resource (if applicable) */
    name?: Maybe<Scalars["String"]["output"]>
    /** Reservations made by the customer */
    reservations: ReservationCollection
    /** Statistics about the customer */
    stats: CustomerStats
    /** Type of the activity owner */
    type?: Maybe<Scalars["String"]["output"]>
  }

/** A customer of a business that may reserve tables in more than one venue */
export type CustomerActivitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
}

/** A customer of a business that may reserve tables in more than one venue */
export type CustomerReservationsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

/** CustomerCollection type */
export type CustomerCollection = {
  __typename?: "CustomerCollection"
  /** A collection of paginated CustomerCollection */
  collection: Array<Customer>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** The contact details for specific customer */
export type CustomerContact = {
  __typename?: "CustomerContact"
  /** URL of the avatar image */
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  /** Contact details */
  customer?: Maybe<Customer>
  /** Email of the customer */
  email?: Maybe<Scalars["String"]["output"]>
  /** ID of the contact details */
  id: Scalars["ID"]["output"]
  /** Full name of the customer */
  name?: Maybe<Scalars["String"]["output"]>
  /** Phone number of the customer */
  phone?: Maybe<Scalars["String"]["output"]>
  /** Phone number formatted for display */
  phoneFormatted?: Maybe<Scalars["String"]["output"]>
}

/** CustomerContactCollection type */
export type CustomerContactCollection = {
  __typename?: "CustomerContactCollection"
  /** A collection of paginated CustomerContactCollection */
  collection: Array<CustomerContact>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** Sorting options for customer contacts */
export enum CustomerContactSort {
  /** Sort by missed reservations */
  MissedReservationsCount = "MISSED_RESERVATIONS_COUNT",
  /** Sort by name */
  Name = "NAME",
  /** Sort by phone number */
  PhoneNumber = "PHONE_NUMBER",
  /** Sort by number of reservations */
  ReservationsCount = "RESERVATIONS_COUNT",
}

/** A customer with their contact information */
export type CustomerInput = {
  /** Email of the customer */
  email?: InputMaybe<Scalars["String"]["input"]>
  /** Name of the customer */
  name?: InputMaybe<Scalars["String"]["input"]>
  /** Phone number of the customer */
  phone?: InputMaybe<Scalars["String"]["input"]>
}

/** A note made by staff on a customer */
export type CustomerNote = {
  __typename?: "CustomerNote"
  /** When the comment was made */
  createdAt: Scalars["ISO8601DateTime"]["output"]
  /** Customer that the comment is about */
  customer: Customer
  /** ID of the comment */
  id: Scalars["ID"]["output"]
  /** Content of the comment */
  note: Scalars["String"]["output"]
  /** User that made the comment */
  user: User
}

/** CustomerNoteCollection type */
export type CustomerNoteCollection = {
  __typename?: "CustomerNoteCollection"
  /** A collection of paginated CustomerNoteCollection */
  collection: Array<CustomerNote>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** Order of customer notes */
export enum CustomerNoteOrder {
  /** Oldest notes first */
  CreatedAtAsc = "CREATED_AT_ASC",
  /** Newest notes first */
  CreatedAtDesc = "CREATED_AT_DESC",
}

/** Statistics about a customer */
export type CustomerStats = {
  __typename?: "CustomerStats"
  /** Statistics about customer reservations */
  reservations: Reservations
}

/** Autogenerated return type of DeleteUser. */
export type DeleteUserPayload = {
  __typename?: "DeleteUserPayload"
  /** The ID of the deleted user */
  deletedUserId?: Maybe<Scalars["ID"]["output"]>
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UsersDeleteUserError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** Application-level feature flags */
export type FeatureFlags = {
  __typename?: "FeatureFlags"
  /** Whether custom reservation rule sections management (add, delete, reorder) is enabled */
  customSectionsEnabled: Scalars["Boolean"]["output"]
}

/** Geographic coordinates (latitude and longitude) */
export type Geocoordinates = {
  __typename?: "Geocoordinates"
  /** Latitude coordinate */
  latitude: Scalars["Float"]["output"]
  /** Longitude coordinate */
  longitude: Scalars["Float"]["output"]
}

/** An image attached to a resource */
export type Image = {
  __typename?: "Image"
  /** Time when the image was created */
  createdAt: Scalars["ISO8601DateTime"]["output"]
  /** ID of the image */
  id: Scalars["ID"]["output"]
  /** Kind of image (avatar, venue_logo, venue_photo) */
  kind: Scalars["String"]["output"]
  /** Time when the image was last updated */
  updatedAt: Scalars["ISO8601DateTime"]["output"]
  /** URL of the image */
  url?: Maybe<Scalars["String"]["output"]>
}

/** Kind of image */
export enum ImageKind {
  /** User avatar image */
  Avatar = "avatar",
  /** Venue logo image */
  VenueLogo = "venue_logo",
  /** Venue photo image */
  VenuePhoto = "venue_photo",
}

export type Mutation = {
  __typename?: "Mutation"
  /** Completes OAuth signup with business details */
  completeOauthSignup: CompleteOauthSignupPayload
  /** Creates a new account with user, business, and venue */
  createAccount: CreateAccountPayload
  /** Creates a new note for a customer by employee */
  createCustomerNote?: Maybe<CreateCustomerNotePayload>
  /** Creates a new reservation by employee */
  createReservation?: Maybe<CreateReservationPayload>
  /** Creates a new note for a reservation by employee */
  createReservationNote?: Maybe<CreateReservationNotePayload>
  /** Creates a new user in the business (admin only) */
  createUser?: Maybe<CreateUserPayload>
  /** Creates a new venue */
  createVenue?: Maybe<CreateVenuePayload>
  /** Deletes a user from the business (admin only) */
  deleteUser?: Maybe<DeleteUserPayload>
  /** Cancels an existing reservation by customer */
  publicCancelReservation: PublicCancelReservationPayload
  /** Confirms a reservation from a public email link */
  publicConfirmReservation: PublicConfirmReservationPayload
  /** Creates a new reservation by customer */
  publicCreateReservation: PublicCreateReservationPayload
  /** Modifies an existing reservation by customer */
  publicModifyReservation: PublicModifyReservationPayload
  /** Sends a password reset email to the given address */
  publicRequestPasswordReset: PublicRequestPasswordResetPayload
  /** Resends a public reservation confirmation email */
  publicResendReservationConfirmation: PublicResendReservationConfirmationPayload
  /** Resets a user password using a token from a reset email */
  publicResetPassword: PublicResetPasswordPayload
  /** Removes an image from a resource */
  removeImage?: Maybe<RemoveImagePayload>
  /** Removes a reservation by employee */
  removeReservation?: Maybe<RemoveReservationPayload>
  /** Updates customer contact information by employee */
  updateCustomerContact?: Maybe<UpdateCustomerContactPayload>
  /** Updates password for the current user */
  updatePassword?: Maybe<UpdatePasswordPayload>
  /** Updates a reservation by employee */
  updateReservation?: Maybe<UpdateReservationPayload>
  /** Updates or creates reservation configuration for a venue */
  updateReservationConfiguration?: Maybe<UpdateReservationConfigurationPayload>
  /** Updates reservation rule sections for a venue */
  updateReservationRuleSections?: Maybe<UpdateReservationRuleSectionsPayload>
  /** Updates user information (admin only) */
  updateUser?: Maybe<UpdateUserPayload>
  /** Updates user information for the current user */
  updateUserInfo?: Maybe<UpdateUserInfoPayload>
  /** Updates a venue and its information */
  updateVenue?: Maybe<UpdateVenuePayload>
  /** Updates venue table groups and tables */
  updateVenueLayout?: Maybe<UpdateVenueLayoutPayload>
  /** Updates venue tags across all categories */
  updateVenueTags?: Maybe<UpdateVenueTagsPayload>
  /** Updates venue working hours */
  updateVenueWorkingHours?: Maybe<UpdateVenueWorkingHoursPayload>
  /** Uploads an image for a resource */
  uploadImage?: Maybe<UploadImagePayload>
}

export type MutationCompleteOauthSignupArgs = {
  businessName: Scalars["String"]["input"]
  country: Country
  phone: Scalars["String"]["input"]
  timezone?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationCreateAccountArgs = {
  businessName: Scalars["String"]["input"]
  country: Country
  email: Scalars["String"]["input"]
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
  phone: Scalars["String"]["input"]
  timezone?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationCreateCustomerNoteArgs = {
  customerId: Scalars["ID"]["input"]
  note: Scalars["String"]["input"]
}

export type MutationCreateReservationArgs = {
  customer?: InputMaybe<CustomerInput>
  notes?: InputMaybe<Array<ReservationNoteInput>>
  peopleAmount?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  tableSlots: Array<TableSlotInput>
  venueId: Scalars["ID"]["input"]
}

export type MutationCreateReservationNoteArgs = {
  note: Scalars["String"]["input"]
  reservationId: Scalars["ID"]["input"]
}

export type MutationCreateUserArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  email: Scalars["String"]["input"]
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
  passwordConfirmation: Scalars["String"]["input"]
  phone?: InputMaybe<Scalars["String"]["input"]>
  position?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  roles?: InputMaybe<Array<UserRoleInput>>
}

export type MutationCreateVenueArgs = {
  country: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  timezone: Scalars["String"]["input"]
}

export type MutationDeleteUserArgs = {
  userId: Scalars["ID"]["input"]
}

export type MutationPublicCancelReservationArgs = {
  reservationId: Scalars["ID"]["input"]
  token: Scalars["String"]["input"]
}

export type MutationPublicConfirmReservationArgs = {
  reservationId: Scalars["ID"]["input"]
  token: Scalars["String"]["input"]
}

export type MutationPublicCreateReservationArgs = {
  customer: PublicCustomerInput
  endTime: Scalars["ISO8601DateTime"]["input"]
  locale?: InputMaybe<Scalars["String"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  peopleAmount: Scalars["Int"]["input"]
  startTime: Scalars["ISO8601DateTime"]["input"]
  tableId: Scalars["String"]["input"]
  venue: Scalars["String"]["input"]
}

export type MutationPublicModifyReservationArgs = {
  customer: PublicCustomerInput
  endTime: Scalars["ISO8601DateTime"]["input"]
  locale?: InputMaybe<Scalars["String"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  originalReservationId: Scalars["ID"]["input"]
  peopleAmount: Scalars["Int"]["input"]
  startTime: Scalars["ISO8601DateTime"]["input"]
  tableId: Scalars["String"]["input"]
  token: Scalars["String"]["input"]
  venue: Scalars["String"]["input"]
}

export type MutationPublicRequestPasswordResetArgs = {
  email: Scalars["String"]["input"]
}

export type MutationPublicResendReservationConfirmationArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>
  reservationId: Scalars["ID"]["input"]
  token?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationPublicResetPasswordArgs = {
  password: Scalars["String"]["input"]
  passwordConfirmation: Scalars["String"]["input"]
  token: Scalars["String"]["input"]
}

export type MutationRemoveImageArgs = {
  associatedId: Scalars["ID"]["input"]
  associatedType: Associated
  imageId: Scalars["ID"]["input"]
}

export type MutationRemoveReservationArgs = {
  reservationId: Scalars["ID"]["input"]
}

export type MutationUpdateCustomerContactArgs = {
  customerContactId: Scalars["ID"]["input"]
  email?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
  phone?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationUpdatePasswordArgs = {
  currentPassword: Scalars["String"]["input"]
  newPassword: Scalars["String"]["input"]
  newPasswordConfirmation: Scalars["String"]["input"]
}

export type MutationUpdateReservationArgs = {
  customerContactId?: InputMaybe<Scalars["ID"]["input"]>
  customerEmail?: InputMaybe<Scalars["String"]["input"]>
  customerName?: InputMaybe<Scalars["String"]["input"]>
  customerPhone?: InputMaybe<Scalars["String"]["input"]>
  endTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>
  peopleAmount?: InputMaybe<Scalars["Int"]["input"]>
  reservationId: Scalars["ID"]["input"]
  startTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>
  status?: InputMaybe<ReservationStatus>
  tableId?: InputMaybe<Scalars["String"]["input"]>
  updateAllContacts?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationUpdateReservationConfigurationArgs = {
  bookingPolicyTiles?: InputMaybe<Array<BookingPolicyTile>>
  cancellationDeadline?: InputMaybe<Scalars["Int"]["input"]>
  largeGroupThreshold?: InputMaybe<Scalars["Int"]["input"]>
  maxAdvanceBookingTime?: InputMaybe<Scalars["Int"]["input"]>
  maxReservationTime?: InputMaybe<Scalars["Int"]["input"]>
  minAdvanceBookingTime?: InputMaybe<Scalars["Int"]["input"]>
  minReservationTime?: InputMaybe<Scalars["Int"]["input"]>
  noshowAutoCancelAfter?: InputMaybe<Scalars["Int"]["input"]>
  reservationBuffer?: InputMaybe<Scalars["Int"]["input"]>
  venueId: Scalars["ID"]["input"]
}

export type MutationUpdateReservationRuleSectionsArgs = {
  sections: Array<ReservationRuleSectionInput>
  venueId: Scalars["ID"]["input"]
}

export type MutationUpdateUserArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>
  avatar?: InputMaybe<Scalars["Upload"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  firstName?: InputMaybe<Scalars["String"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  position?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  removeAvatar?: InputMaybe<Scalars["Boolean"]["input"]>
  roles?: InputMaybe<Array<UserRoleInput>>
  userId: Scalars["ID"]["input"]
}

export type MutationUpdateUserInfoArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>
  avatar?: InputMaybe<Scalars["Upload"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  firstName?: InputMaybe<Scalars["String"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  position?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  removeAvatar?: InputMaybe<Scalars["Boolean"]["input"]>
  userId: Scalars["ID"]["input"]
}

export type MutationUpdateVenueArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  latitude?: InputMaybe<Scalars["Float"]["input"]>
  longitude?: InputMaybe<Scalars["Float"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  socialAccounts?: InputMaybe<Scalars["JSON"]["input"]>
  timezone?: InputMaybe<Scalars["String"]["input"]>
  venueId: Scalars["ID"]["input"]
  venueLogo?: InputMaybe<Scalars["Upload"]["input"]>
  website?: InputMaybe<Scalars["String"]["input"]>
  zipcode?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationUpdateVenueLayoutArgs = {
  plans?: InputMaybe<Array<VenuePlanInput>>
  tableGroups: Array<TableGroupLayoutInput>
  venueId: Scalars["ID"]["input"]
}

export type MutationUpdateVenueTagsArgs = {
  tags: Scalars["JSON"]["input"]
  venueId: Scalars["ID"]["input"]
}

export type MutationUpdateVenueWorkingHoursArgs = {
  venueId: Scalars["ID"]["input"]
  workingHours: Array<VenueWorkingHourInput>
}

export type MutationUploadImageArgs = {
  associatedId: Scalars["ID"]["input"]
  associatedType: Associated
  image: Scalars["Upload"]["input"]
  kind: ImageKind
}

/** Available OAuth providers */
export type OauthProviders = {
  __typename?: "OauthProviders"
  /** Whether Facebook OAuth is enabled */
  facebookEnabled: Scalars["Boolean"]["output"]
  /** Whether Google OAuth is enabled */
  googleEnabled: Scalars["Boolean"]["output"]
}

/** OAuth signup data stored in session */
export type OauthSignupData = {
  __typename?: "OauthSignupData"
  /** Email from OAuth provider */
  email: Scalars["String"]["output"]
  /** First name from OAuth provider */
  firstName?: Maybe<Scalars["String"]["output"]>
  /** Last name from OAuth provider */
  lastName?: Maybe<Scalars["String"]["output"]>
  /** OAuth provider name */
  provider: Scalars["String"]["output"]
}

/** Opening hours for regular and special schedules */
export type OpeningHour = {
  __typename?: "OpeningHour"
  /** Whether the venue is closed */
  closed?: Maybe<Scalars["Boolean"]["output"]>
  /** End date for special hours */
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>
  /** Closing time */
  endTime?: Maybe<Scalars["String"]["output"]>
  /** Unique identifier */
  id: Scalars["ID"]["output"]
  /** Type of opening hours */
  kind?: Maybe<OpeningHourKind>
  /** Start date for special hours */
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>
  /** Opening time */
  startTime?: Maybe<Scalars["String"]["output"]>
  /** Associated venue */
  venue: Venue
  /** Day of the week (0-6) */
  weekday?: Maybe<Scalars["Int"]["output"]>
}

/** Type of opening hours */
export enum OpeningHourKind {
  /** Regular recurring opening hours */
  Regular = "regular",
  /** Special one-time or date-specific opening hours */
  Special = "special",
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo"
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>
}

/** Public facing API available to non-logged in customers */
export type Public = {
  __typename?: "Public"
  /** Get a reservation by UUID to display to customer */
  reservation?: Maybe<PublicReservation>
  /** Get a venue by slug to display to customer */
  venue?: Maybe<PublicVenue>
}

/** Public facing API available to non-logged in customers */
export type PublicReservationArgs = {
  uuid: Scalars["ID"]["input"]
}

/** Public facing API available to non-logged in customers */
export type PublicVenueArgs = {
  slug: Scalars["ID"]["input"]
}

/** Available public booking policy tile kinds */
export enum PublicBookingPolicyTile {
  /** Cancellation */
  Cancellation = "cancellation",
  /** Group reservations */
  GroupReservations = "group_reservations",
  /** Running late */
  RunningLate = "running_late",
  /** Time limit */
  TimeLimit = "time_limit",
}

/** An anonymized time block when a table is reserved (includes buffer if configured) */
export type PublicBusyBlock = {
  __typename?: "PublicBusyBlock"
  /** End time of the busy block (includes buffer if configured) */
  endTime: Scalars["ISO8601DateTime"]["output"]
  /** Start time of the busy block */
  startTime: Scalars["ISO8601DateTime"]["output"]
}

/** A generic error type for mutations */
export type PublicCancelReservationError = {
  __typename?: "PublicCancelReservationError"
  /** A machine-friendly code for the error */
  code: PublicCancelReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicCancelReservationErrorEnum {
  /** The cancellation deadline for this reservation has passed */
  CancellationDeadlinePassed = "CANCELLATION_DEADLINE_PASSED",
  /** This reservation cannot be cancelled */
  NotCancellable = "NOT_CANCELLABLE",
}

/** Autogenerated return type of PublicCancelReservation. */
export type PublicCancelReservationPayload = {
  __typename?: "PublicCancelReservationPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicCancelReservationError>>
  /** The reservation */
  reservation?: Maybe<PublicReservation>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type PublicConfirmReservationError = {
  __typename?: "PublicConfirmReservationError"
  /** A machine-friendly code for the error */
  code: PublicConfirmReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicConfirmReservationErrorEnum {
  /** This reservation confirmation has expired */
  Expired = "EXPIRED",
  /** This reservation confirmation link is invalid */
  Invalid = "INVALID",
  /** This reservation can no longer be confirmed */
  NotConfirmable = "NOT_CONFIRMABLE",
}

/** Autogenerated return type of PublicConfirmReservation. */
export type PublicConfirmReservationPayload = {
  __typename?: "PublicConfirmReservationPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicConfirmReservationError>>
  /** The reservation */
  reservation?: Maybe<PublicReservation>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type PublicCreateReservationError = {
  __typename?: "PublicCreateReservationError"
  /** A machine-friendly code for the error */
  code: PublicCreateReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicCreateReservationErrorEnum {
  /** There is another reservation that overlaps with this one */
  Overlaps = "OVERLAPS",
  /** The venue is closed during the requested time */
  VenueClosed = "VENUE_CLOSED",
}

/** Autogenerated return type of PublicCreateReservation. */
export type PublicCreateReservationPayload = {
  __typename?: "PublicCreateReservationPayload"
  /** The time until the reservation can be confirmed */
  confirmUntil?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicCreateReservationError>>
  /** The earliest time another confirmation email can be resent */
  resendAvailableAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** How many resend attempts are still available */
  resendsRemaining?: Maybe<Scalars["Int"]["output"]>
  /** The created reservation */
  reservation?: Maybe<PublicReservation>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** Customer information for public reservation booking */
export type PublicCustomerInput = {
  /** Email of the customer */
  email: Scalars["String"]["input"]
  /** Whether customer opted in to marketing communications */
  marketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>
  /** Name of the customer */
  name: Scalars["String"]["input"]
  /** Phone number of the customer */
  phone: Scalars["String"]["input"]
}

/** An image attached to a resource */
export type PublicImage = {
  __typename?: "PublicImage"
  /** ID of the image */
  id: Scalars["ID"]["output"]
  /** Kind of image (avatar, venue_logo, venue_photo) */
  kind: Scalars["String"]["output"]
  /** URL of the image */
  url?: Maybe<Scalars["String"]["output"]>
}

/** A generic error type for mutations */
export type PublicModifyReservationError = {
  __typename?: "PublicModifyReservationError"
  /** A machine-friendly code for the error */
  code: PublicModifyReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicModifyReservationErrorEnum {
  /** The modification deadline for this reservation has passed */
  ModificationDeadlinePassed = "MODIFICATION_DEADLINE_PASSED",
  /** This reservation cannot be modified */
  NotModifiable = "NOT_MODIFIABLE",
  /** There is another reservation that overlaps with this one */
  Overlaps = "OVERLAPS",
  /** The venue is closed during the requested time */
  VenueClosed = "VENUE_CLOSED",
}

/** Autogenerated return type of PublicModifyReservation. */
export type PublicModifyReservationPayload = {
  __typename?: "PublicModifyReservationPayload"
  /** The time until the reservation can be confirmed */
  confirmUntil?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicModifyReservationError>>
  /** The earliest time another confirmation email can be resent */
  resendAvailableAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** How many resend attempts are still available */
  resendsRemaining?: Maybe<Scalars["Int"]["output"]>
  /** The new reservation */
  reservation?: Maybe<PublicReservation>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** Opening hours for regular and special schedules */
export type PublicOpeningHour = {
  __typename?: "PublicOpeningHour"
  /** Whether the venue is closed */
  closed?: Maybe<Scalars["Boolean"]["output"]>
  /** End date for special hours */
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>
  /** Closing time */
  endTime?: Maybe<Scalars["String"]["output"]>
  /** Unique identifier */
  id: Scalars["ID"]["output"]
  /** Type of opening hours */
  kind?: Maybe<OpeningHourKind>
  /** Start date for special hours */
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>
  /** Opening time */
  startTime?: Maybe<Scalars["String"]["output"]>
  /** Day of the week (0-6) */
  weekday?: Maybe<Scalars["Int"]["output"]>
}

/** A generic error type for mutations */
export type PublicRequestPasswordResetError = {
  __typename?: "PublicRequestPasswordResetError"
  /** A machine-friendly code for the error */
  code: PublicRequestPasswordResetErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicRequestPasswordResetErrorEnum {
  /** There was a problem sending the password reset email */
  Generic = "GENERIC",
}

/** Autogenerated return type of PublicRequestPasswordReset. */
export type PublicRequestPasswordResetPayload = {
  __typename?: "PublicRequestPasswordResetPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicRequestPasswordResetError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type PublicResendReservationConfirmationError = {
  __typename?: "PublicResendReservationConfirmationError"
  /** A machine-friendly code for the error */
  code: PublicResendReservationConfirmationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicResendReservationConfirmationErrorEnum {
  /** This reservation can no longer be confirmed */
  NotConfirmable = "NOT_CONFIRMABLE",
  /** Please wait before requesting another confirmation email */
  TooEarly = "TOO_EARLY",
  /** You have reached the resend limit */
  TooManyAttempts = "TOO_MANY_ATTEMPTS",
}

/** Autogenerated return type of PublicResendReservationConfirmation. */
export type PublicResendReservationConfirmationPayload = {
  __typename?: "PublicResendReservationConfirmationPayload"
  /** The time until the reservation can be confirmed */
  confirmUntil?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicResendReservationConfirmationError>>
  /** The earliest time another confirmation email can be resent */
  resendAvailableAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** How many resend attempts are still available */
  resendsRemaining?: Maybe<Scalars["Int"]["output"]>
  /** The reservation */
  reservation?: Maybe<PublicReservation>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A public (non-employee) information about reservation */
export type PublicReservation = {
  __typename?: "PublicReservation"
  /** Whether the reservation can still be cancelled */
  canCancel: Scalars["Boolean"]["output"]
  /** Whether the cancellation flow should still be offered to the customer */
  canStartCancellation: Scalars["Boolean"]["output"]
  /** Time until which the reservation can be cancelled */
  cancellationDeadlineAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** Time until the reservation can be confirmed */
  confirmUntil?: Maybe<Scalars["ISO8601DateTime"]["output"]>
  /** Note provided by the customer */
  customerNote?: Maybe<Scalars["String"]["output"]>
  /** Email of the customer */
  email?: Maybe<Scalars["String"]["output"]>
  /** End time of the reservation */
  endTime: Scalars["ISO8601DateTime"]["output"]
  /** UUID of the reservation */
  id: Scalars["ID"]["output"]
  /** Language used for customer-facing reservation communication */
  locale: Scalars["String"]["output"]
  /** Name of the customer */
  name?: Maybe<Scalars["String"]["output"]>
  /** Number of people for the reservation */
  peopleAmount?: Maybe<Scalars["Int"]["output"]>
  /** Phone of the customer */
  phone?: Maybe<Scalars["String"]["output"]>
  /** Human-readable reference number */
  referenceNumber: Scalars["String"]["output"]
  /** Start time of the reservation */
  startTime: Scalars["ISO8601DateTime"]["output"]
  /** Status of the reservation */
  status: PublicReservationStatus
  /** ID of the table for which the reservation was made */
  tableId: Scalars["ID"]["output"]
  /** Table name for which the reservation was made */
  tableName: Scalars["String"]["output"]
  /** Timezone of the venue */
  timezone: Scalars["String"]["output"]
  /** Venue for which the reservation was made */
  venue: PublicVenue
  /** Venue name for which the reservation was made */
  venueName: Scalars["String"]["output"]
}

/** Reservation configuration for a venue */
export type PublicReservationConfiguration = {
  __typename?: "PublicReservationConfiguration"
  /** All available public booking policy tiles in default order */
  availableBookingPolicyTiles: Array<PublicBookingPolicyTile>
  /** Enabled public booking policy tiles in the configured order */
  bookingPolicyTiles: Array<PublicBookingPolicyTile>
  /** Cancellation deadline (seconds before reservation) */
  cancellationDeadline?: Maybe<Scalars["Int"]["output"]>
  /** Group size threshold for large groups */
  largeGroupThreshold?: Maybe<Scalars["Int"]["output"]>
  /** Maximum advance booking time in seconds */
  maxAdvanceBookingTime?: Maybe<Scalars["Int"]["output"]>
  /** Maximum reservation duration in seconds */
  maxReservationTime?: Maybe<Scalars["Int"]["output"]>
  /** Minimum advance booking time in seconds */
  minAdvanceBookingTime?: Maybe<Scalars["Int"]["output"]>
  /** Minimum reservation duration in seconds */
  minReservationTime?: Maybe<Scalars["Int"]["output"]>
  /** Time after which no-show reservations are auto-cancelled (in seconds) */
  noshowAutoCancelAfter?: Maybe<Scalars["Int"]["output"]>
  /** Buffer time between reservations in seconds */
  reservationBuffer?: Maybe<Scalars["Int"]["output"]>
}

/** A custom section for reservation rules */
export type PublicReservationRuleSection = {
  __typename?: "PublicReservationRuleSection"
  /** Section content (markdown) */
  content?: Maybe<Scalars["String"]["output"]>
  /** Unique identifier */
  id: Scalars["ID"]["output"]
  /** Stable internal identifier (e.g. venue_plan) */
  identifier: Scalars["String"]["output"]
  /** Sort position */
  position: Scalars["Int"]["output"]
  /** Section title */
  title: Scalars["String"]["output"]
}

/** Status of a reservation */
export enum PublicReservationStatus {
  /** Reservation was cancelled */
  Cancelled = "cancelled",
  /** Reservation is confirmed */
  Confirmed = "confirmed",
  /** Pending confirmation from customer */
  Pending = "pending",
}

/** A generic error type for mutations */
export type PublicResetPasswordError = {
  __typename?: "PublicResetPasswordError"
  /** A machine-friendly code for the error */
  code: PublicResetPasswordErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum PublicResetPasswordErrorEnum {
  /** There was a problem resetting your password */
  Generic = "GENERIC",
  /** This password reset link is invalid or has expired */
  InvalidToken = "INVALID_TOKEN",
  /** The new password is invalid */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of PublicResetPassword. */
export type PublicResetPasswordPayload = {
  __typename?: "PublicResetPasswordPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<PublicResetPasswordError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A table, as visible by customer */
export type PublicTable = {
  __typename?: "PublicTable"
  /** ID of the table */
  id: Scalars["ID"]["output"]
  /** Maximum number of guests for this table */
  maxCapacity?: Maybe<Scalars["Int"]["output"]>
  /** Minimum number of guests for this table */
  minCapacity?: Maybe<Scalars["Int"]["output"]>
  /** Name of the table */
  name: Scalars["String"]["output"]
  /** Table group to which the table belongs */
  tableGroup: PublicTableGroup
}

/** A table-specific busy time block used to aggregate public availability */
export type PublicTableBusyBlock = {
  __typename?: "PublicTableBusyBlock"
  /** End time of the busy block (includes reservation buffer if configured) */
  endTime: Scalars["ISO8601DateTime"]["output"]
  /** Start time of the busy block */
  startTime: Scalars["ISO8601DateTime"]["output"]
  /** The table associated with the busy block */
  tableId: Scalars["ID"]["output"]
}

/** A table group, as visible by customer */
export type PublicTableGroup = {
  __typename?: "PublicTableGroup"
  /** ID of the table group */
  id: Scalars["ID"]["output"]
  /** Name of the table group */
  name: Scalars["String"]["output"]
}

/** A venue, a place where reservations can be made */
export type PublicVenue = {
  __typename?: "PublicVenue"
  /** Anonymized busy time blocks for a specific table on a specific date */
  busyBlocks: Array<PublicBusyBlock>
  /** Country of the area where venue is located */
  country: Scalars["String"]["output"]
  /** Default locale used for customer-facing venue flows */
  defaultLocale: Scalars["String"]["output"]
  /** Images associated with the venue */
  images: Array<PublicImage>
  /** Additional information about the venue */
  info?: Maybe<PublicVenueInfo>
  /** Name of the venue */
  name: Scalars["String"]["output"]
  /** Whether the venue is open during the specified time range */
  open: Scalars["Boolean"]["output"]
  /** Opening hours for the venue */
  openingHours: Array<PublicOpeningHour>
  /** Plan sections of the venue */
  plans: Array<PublicVenuePlan>
  /** Reservation configuration for the venue */
  reservationConfiguration?: Maybe<PublicReservationConfiguration>
  /** Custom reservation rule sections */
  reservationRuleSections: Array<PublicReservationRuleSection>
  /** Unique slug of the venue */
  slug: Scalars["String"]["output"]
  /** Busy time blocks for all active tables on a specific date, including overnight carry-over */
  tableBusyBlocksByDate: Array<PublicTableBusyBlock>
  /** Active seating areas in the venue */
  tableGroups: Array<PublicTableGroup>
  /** Tables that belong to the venue */
  tables: Array<PublicTable>
  /** Tags assigned to the venue */
  tags: Array<VenueTag>
  /** Timezone of the area where venue is located */
  timezone: Scalars["String"]["output"]
}

/** A venue, a place where reservations can be made */
export type PublicVenueBusyBlocksArgs = {
  date: Scalars["ISO8601Date"]["input"]
  excludeReservationId?: InputMaybe<Scalars["ID"]["input"]>
  tableId: Scalars["ID"]["input"]
}

/** A venue, a place where reservations can be made */
export type PublicVenueImagesArgs = {
  kind?: InputMaybe<Array<ImageKind>>
}

/** A venue, a place where reservations can be made */
export type PublicVenueOpenArgs = {
  endTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>
  startTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>
}

/** A venue, a place where reservations can be made */
export type PublicVenueTableBusyBlocksByDateArgs = {
  date: Scalars["ISO8601Date"]["input"]
}

/** Additional information about a venue */
export type PublicVenueInfo = {
  __typename?: "PublicVenueInfo"
  /** Street address of the venue */
  address?: Maybe<Scalars["String"]["output"]>
  /** City where the venue is located */
  city?: Maybe<Scalars["String"]["output"]>
  /** Description of the venue */
  description?: Maybe<Scalars["String"]["output"]>
  /** Contact email address */
  email?: Maybe<Scalars["String"]["output"]>
  /** Latitude coordinate of the venue */
  latitude?: Maybe<Scalars["Float"]["output"]>
  /** Longitude coordinate of the venue */
  longitude?: Maybe<Scalars["Float"]["output"]>
  /** Contact phone number */
  phone?: Maybe<Scalars["String"]["output"]>
  /** Formatted contact phone number */
  phoneFormatted?: Maybe<Scalars["String"]["output"]>
  /** Social media accounts */
  socialAccounts?: Maybe<Scalars["JSON"]["output"]>
  /** Website URL */
  website?: Maybe<Scalars["String"]["output"]>
  /** Postal/ZIP code of the venue */
  zipcode?: Maybe<Scalars["String"]["output"]>
}

/** A plan section for a venue */
export type PublicVenuePlan = {
  __typename?: "PublicVenuePlan"
  /** Whether this is the default plan for the venue */
  default: Scalars["Boolean"]["output"]
  /** ID of the venue plan */
  id: Scalars["ID"]["output"]
  /** SVG content of the plan */
  plan?: Maybe<Scalars["String"]["output"]>
  /** Position/order of the plan */
  position: Scalars["Int"]["output"]
  /** Name of the plan section */
  sectionName?: Maybe<Scalars["String"]["output"]>
}

/** The query root of this schema */
export type Query = {
  __typename?: "Query"
  /** Get application configuration */
  appConfig: AppConfig
  /** Get the current business */
  business?: Maybe<Business>
  /** Get the current user */
  currentUser?: Maybe<CurrentUser>
  /** Get application-level feature flags */
  featureFlags: FeatureFlags
  /** Geocode an address to coordinates */
  geocodeAddress?: Maybe<Geocoordinates>
  /** Get available OAuth providers */
  oauthProviders: OauthProviders
  /** Get OAuth signup data from session */
  oauthSignupData?: Maybe<OauthSignupData>
  /** Public facing API available to non-logged in customers */
  public: Public
  /** Get a reservation by ID */
  reservation?: Maybe<Reservation>
  /** Get all venue tag category definitions with available options */
  tagDefinitions: Array<TagCategoryDefinition>
  /** Get all users in the business (admin only) */
  users?: Maybe<UserCollection>
  /** Get a venue by ID, if the ID is not provided it will pick the first venue of the business */
  venue?: Maybe<Venue>
  /** Get all venues of the business */
  venues?: Maybe<Array<Venue>>
}

/** The query root of this schema */
export type QueryGeocodeAddressArgs = {
  address: Scalars["String"]["input"]
}

/** The query root of this schema */
export type QueryReservationArgs = {
  id: Scalars["ID"]["input"]
  slug?: InputMaybe<Scalars["ID"]["input"]>
}

/** The query root of this schema */
export type QueryUsersArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  sortBy?: InputMaybe<UserSortField>
  sortDirection?: InputMaybe<SortDirection>
}

/** The query root of this schema */
export type QueryVenueArgs = {
  slug?: InputMaybe<Scalars["ID"]["input"]>
}

/** A generic error type for mutations */
export type RemoveImageError = {
  __typename?: "RemoveImageError"
  /** A machine-friendly code for the error */
  code: RemoveImageErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum RemoveImageErrorEnum {
  /** There was a problem while removing the image */
  Generic = "GENERIC",
  /** Image not found */
  NotFound = "NOT_FOUND",
  /** You are not authorized to remove this image */
  Unauthorized = "UNAUTHORIZED",
}

/** Autogenerated return type of RemoveImage. */
export type RemoveImagePayload = {
  __typename?: "RemoveImagePayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<RemoveImageError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type RemoveReservationError = {
  __typename?: "RemoveReservationError"
  /** A machine-friendly code for the error */
  code: RemoveReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum RemoveReservationErrorEnum {
  /** There was a problem while removing the reservation */
  Generic = "GENERIC",
}

/** Autogenerated return type of RemoveReservation. */
export type RemoveReservationPayload = {
  __typename?: "RemoveReservationPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<RemoveReservationError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A reservation for a table in a venue, done by a customer */
export type Reservation = ActivityResourceInterface & {
  __typename?: "Reservation"
  /** History log of the reservation */
  activities: ActivityConnection
  /** Customer who made the reservation */
  customer?: Maybe<Customer>
  /** Customer contact information */
  customerContact?: Maybe<CustomerContact>
  /** Note provided by the customer */
  customerNote?: Maybe<Scalars["String"]["output"]>
  /** End time of the reservation */
  endTime: Scalars["ISO8601DateTime"]["output"]
  /** ID of the reservation */
  id: Scalars["ID"]["output"]
  /** Language used for customer-facing reservation communication */
  locale: Scalars["String"]["output"]
  /** Name of the resource (if applicable) */
  name?: Maybe<Scalars["String"]["output"]>
  /** Notes for the reservation */
  notes: ReservationNoteConnection
  /** Number of people for the reservation */
  peopleAmount?: Maybe<Scalars["Int"]["output"]>
  /** Start time of the reservation */
  startTime: Scalars["ISO8601DateTime"]["output"]
  /** Status of the reservation */
  status: ReservationStatus
  /** Table for which the reservation was made */
  table: Table
  /** Venue for which the reservation was made */
  venue: Venue
}

/** A reservation for a table in a venue, done by a customer */
export type ReservationActivitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
}

/** A reservation for a table in a venue, done by a customer */
export type ReservationNotesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
}

/** ReservationCollection type */
export type ReservationCollection = {
  __typename?: "ReservationCollection"
  /** A collection of paginated ReservationCollection */
  collection: Array<Reservation>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** Reservation configuration for a venue */
export type ReservationConfiguration = {
  __typename?: "ReservationConfiguration"
  /** All available booking policy tiles in default order */
  availableBookingPolicyTiles: Array<BookingPolicyTile>
  /** Enabled booking policy tiles in the configured order */
  bookingPolicyTiles: Array<BookingPolicyTile>
  /** Cancellation deadline (seconds before reservation) */
  cancellationDeadline?: Maybe<Scalars["Int"]["output"]>
  /** Timestamp when record was created */
  createdAt: Scalars["ISO8601DateTime"]["output"]
  /** Unique identifier */
  id: Scalars["ID"]["output"]
  /** Group size threshold for large groups */
  largeGroupThreshold?: Maybe<Scalars["Int"]["output"]>
  /** Maximum advance booking time in seconds */
  maxAdvanceBookingTime?: Maybe<Scalars["Int"]["output"]>
  /** Maximum reservation duration in seconds */
  maxReservationTime?: Maybe<Scalars["Int"]["output"]>
  /** Minimum advance booking time in seconds */
  minAdvanceBookingTime?: Maybe<Scalars["Int"]["output"]>
  /** Minimum reservation duration in seconds */
  minReservationTime?: Maybe<Scalars["Int"]["output"]>
  /** Time after which no-show reservations are auto-cancelled (in seconds) */
  noshowAutoCancelAfter?: Maybe<Scalars["Int"]["output"]>
  /** Buffer time between reservations in seconds */
  reservationBuffer?: Maybe<Scalars["Int"]["output"]>
  /** Timestamp when record was updated */
  updatedAt: Scalars["ISO8601DateTime"]["output"]
  /** ID of the associated venue */
  venueId: Scalars["ID"]["output"]
}

/** The connection type for Reservation. */
export type ReservationConnection = {
  __typename?: "ReservationConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReservationEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Reservation>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** Total count of items in all pages. */
  totalCount: Scalars["Int"]["output"]
}

/** Date field to filter reservations by */
export enum ReservationDateField {
  /** Filter by when the reservation was made/created */
  CreatedDate = "CREATED_DATE",
  /** Filter by when the reservation is scheduled to happen */
  ReservationDate = "RESERVATION_DATE",
}

/** Filter reservations by date */
export type ReservationDateFilterInput = {
  /** Which date field to filter on */
  field: ReservationDateField
  /** Start of date range (inclusive) */
  from?: InputMaybe<Scalars["ISO8601Date"]["input"]>
  /** End of date range (inclusive) */
  to?: InputMaybe<Scalars["ISO8601Date"]["input"]>
}

/** An edge in a connection. */
export type ReservationEdge = {
  __typename?: "ReservationEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<Reservation>
}

/** A note that is attached to a reservation, usually added by an employee (User) */
export type ReservationNote = {
  __typename?: "ReservationNote"
  /** Avatar URL of the user that created the note */
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  /** Time when the note was created */
  createdAt: Scalars["ISO8601DateTime"]["output"]
  /** ID of the reservation note */
  id: Scalars["ID"]["output"]
  /** Name of the user that created the note */
  name?: Maybe<Scalars["String"]["output"]>
  /** The note contents */
  note: Scalars["String"]["output"]
  /** Reservation for which the note was created */
  reservation: Reservation
  /** Source of the note */
  source: ReservationNoteSource
  /** Staff member that created the note */
  user?: Maybe<User>
}

/** The connection type for ReservationNote. */
export type ReservationNoteConnection = {
  __typename?: "ReservationNoteConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReservationNoteEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReservationNote>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** Total count of items in all pages. */
  totalCount: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ReservationNoteEdge = {
  __typename?: "ReservationNoteEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<ReservationNote>
}

/** A note to be added to a reservation */
export type ReservationNoteInput = {
  /** The note content */
  note: Scalars["String"]["input"]
}

/** Source of a reservation note */
export enum ReservationNoteSource {
  /** Note was added by the customer */
  Customer = "customer",
  /** Note was added by a staff member */
  Staff = "staff",
  /** Note was added by the system */
  System = "system",
}

/** A custom section for reservation rules */
export type ReservationRuleSection = {
  __typename?: "ReservationRuleSection"
  /** Section content (markdown) */
  content?: Maybe<Scalars["String"]["output"]>
  /** Unique identifier */
  id: Scalars["ID"]["output"]
  /** Stable internal identifier (e.g. venue_plan) */
  identifier: Scalars["String"]["output"]
  /** Sort position */
  position: Scalars["Int"]["output"]
  /** Section title */
  title: Scalars["String"]["output"]
}

/** Input for reservation rule section */
export type ReservationRuleSectionInput = {
  /** Section content (markdown) */
  content?: InputMaybe<Scalars["String"]["input"]>
  /** ID of existing section (for updates) */
  id?: InputMaybe<Scalars["ID"]["input"]>
  /** Section title */
  title: Scalars["String"]["input"]
}

/** Status of a reservation */
export enum ReservationStatus {
  /** Reservation was cancelled */
  Cancelled = "cancelled",
  /** Reservation is confirmed */
  Confirmed = "confirmed",
  /** Customer did not show up */
  NoShow = "no_show",
  /** Reservation is pending */
  Pending = "pending",
  /** Reservation was removed by staff */
  Removed = "removed",
  /** Customer is seated */
  Seated = "seated",
  /** Customer walked in without previous reservation */
  WalkIn = "walk_in",
}

/** Statistics about customer reservations */
export type Reservations = {
  __typename?: "Reservations"
  /** Number of reservations cancelled by customer */
  cancelled: Scalars["Int"]["output"]
  /** Number of reservations where customer did not come */
  noShow: Scalars["Int"]["output"]
  /** Number of reservations not yet confirmed */
  pending: Scalars["Int"]["output"]
  /** Number of reservations where customer was seated */
  seated: Scalars["Int"]["output"]
  /** Total number of reservations made by customer */
  total: Scalars["Int"]["output"]
}

/** User role type */
export enum Role {
  /** Administrator role */
  Admin = "ADMIN",
  /** Manager role */
  Manager = "MANAGER",
  /** Staff role */
  Staff = "STAFF",
}

/** Sorting direction options */
export enum SortDirection {
  /** Sort in ascending order */
  Asc = "ASC",
  /** Sort in descending order */
  Desc = "DESC",
}

/** A single table in a venue */
export type Table = {
  __typename?: "Table"
  /** Whether the table is deleted */
  deleted: Scalars["Boolean"]["output"]
  /** ID of the table */
  id: Scalars["ID"]["output"]
  /** Maximum number of guests for this table */
  maxCapacity?: Maybe<Scalars["Int"]["output"]>
  /** Minimum number of guests for this table */
  minCapacity?: Maybe<Scalars["Int"]["output"]>
  /** Name of the table */
  name: Scalars["String"]["output"]
  /** Table group to which the table belongs */
  tableGroup: TableGroup
  /** Venue to which the table belongs */
  venue: Venue
}

/** A group of tables that are usually located in the same area of the venue (for example "VIP Room") */
export type TableGroup = {
  __typename?: "TableGroup"
  /** Whether the table group is deleted */
  deleted: Scalars["Boolean"]["output"]
  /** ID of the table group */
  id: Scalars["ID"]["output"]
  /** Name of the table group */
  name: Scalars["String"]["output"]
  /** Tables that belong to the table group */
  tables: Array<Table>
  /** Venue to which the table group belongs */
  venue: Venue
}

/** A group of tables that are usually located in the same area of the venue (for example "VIP Room") */
export type TableGroupTablesArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Input for a table group in the layout */
export type TableGroupLayoutInput = {
  /** ID of the table group (null for new groups) */
  id?: InputMaybe<Scalars["ID"]["input"]>
  /** Name of the table group */
  name: Scalars["String"]["input"]
  /** Tables in this group */
  tables: Array<TableLayoutInput>
}

/** Input for a table in the layout */
export type TableLayoutInput = {
  /** ID of the table (null for new tables) */
  id?: InputMaybe<Scalars["ID"]["input"]>
  /** Maximum number of guests for this table */
  maxCapacity?: InputMaybe<Scalars["Int"]["input"]>
  /** Minimum number of guests for this table */
  minCapacity?: InputMaybe<Scalars["Int"]["input"]>
  /** Name of the table */
  name: Scalars["String"]["input"]
}

/** A table slot with its own start and end time for a reservation */
export type TableSlotInput = {
  /** End time for this table */
  endTime: Scalars["ISO8601DateTime"]["input"]
  /** Start time for this table */
  startTime: Scalars["ISO8601DateTime"]["input"]
  /** The ID of the table */
  tableId: Scalars["ID"]["input"]
}

/** Definition of a venue tag category with available options and rules */
export type TagCategoryDefinition = {
  __typename?: "TagCategoryDefinition"
  /** Whether custom values are allowed */
  allowCustom: Scalars["Boolean"]["output"]
  /** i18n-resolved description text for this category */
  descriptionText?: Maybe<Scalars["String"]["output"]>
  /** Category identifier (e.g. "venue_type", "cuisine") */
  key: Scalars["String"]["output"]
  /** i18n-resolved display name for this category */
  label: Scalars["String"]["output"]
  /** Maximum number of selections (nil = unlimited) */
  maxSelections?: Maybe<Scalars["Int"]["output"]>
  /** Available options for this category */
  options: Array<TagOption>
  /** Selection type: "single" or "multi" */
  selectionType: Scalars["String"]["output"]
}

/** A single option within a tag category */
export type TagOption = {
  __typename?: "TagOption"
  /** i18n-resolved display label */
  label: Scalars["String"]["output"]
  /** Subcategory grouping (e.g. "dining", "bars_and_nightlife") */
  subcategory?: Maybe<Scalars["String"]["output"]>
  /** Canonical lowercase key for this option */
  value: Scalars["String"]["output"]
}

/** A generic error type for mutations */
export type UpdateCustomerContactError = {
  __typename?: "UpdateCustomerContactError"
  /** A machine-friendly code for the error */
  code: UpdateCustomerContactErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateCustomerContactErrorEnum {
  /** There was a problem while updating the customer contact */
  Generic = "GENERIC",
  /** Customer contact not found */
  NotFound = "NOT_FOUND",
  /** You are not authorized to update this customer contact */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid customer contact data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateCustomerContact. */
export type UpdateCustomerContactPayload = {
  __typename?: "UpdateCustomerContactPayload"
  /** The updated customer contact */
  customerContact?: Maybe<CustomerContact>
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateCustomerContactError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type UpdatePasswordError = {
  __typename?: "UpdatePasswordError"
  /** A machine-friendly code for the error */
  code: UpdatePasswordErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdatePasswordErrorEnum {
  /** There was a problem while updating the password */
  Generic = "GENERIC",
  /** Current password is incorrect */
  IncorrectPassword = "INCORRECT_PASSWORD",
  /** You are not authorized to update this password */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid password data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdatePassword. */
export type UpdatePasswordPayload = {
  __typename?: "UpdatePasswordPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdatePasswordError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated user */
  user?: Maybe<User>
}

/** A generic error type for mutations */
export type UpdateReservationConfigurationError = {
  __typename?: "UpdateReservationConfigurationError"
  /** A machine-friendly code for the error */
  code: UpdateReservationConfigurationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateReservationConfigurationErrorEnum {
  /** There was a problem while updating the reservation configuration */
  Generic = "GENERIC",
  /** You are not authorized to update this reservation configuration */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid reservation configuration data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateReservationConfiguration. */
export type UpdateReservationConfigurationPayload = {
  __typename?: "UpdateReservationConfigurationPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateReservationConfigurationError>>
  /** The updated reservation configuration */
  reservationConfiguration?: Maybe<ReservationConfiguration>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type UpdateReservationError = {
  __typename?: "UpdateReservationError"
  /** A machine-friendly code for the error */
  code: UpdateReservationErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateReservationErrorEnum {
  /** There was a problem while updating the reservation */
  Generic = "GENERIC",
}

/** Autogenerated return type of UpdateReservation. */
export type UpdateReservationPayload = {
  __typename?: "UpdateReservationPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateReservationError>>
  /** The updated reservation */
  reservation?: Maybe<Reservation>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type UpdateReservationRuleSectionsError = {
  __typename?: "UpdateReservationRuleSectionsError"
  /** A machine-friendly code for the error */
  code: UpdateReservationRuleSectionsErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateReservationRuleSectionsErrorEnum {
  /** There was a problem while updating the reservation rule sections */
  Generic = "GENERIC",
  /** You are not authorized to update reservation rules */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid section data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateReservationRuleSections. */
export type UpdateReservationRuleSectionsPayload = {
  __typename?: "UpdateReservationRuleSectionsPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateReservationRuleSectionsError>>
  /** The updated sections */
  sections?: Maybe<Array<ReservationRuleSection>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A generic error type for mutations */
export type UpdateUserInfoError = {
  __typename?: "UpdateUserInfoError"
  /** A machine-friendly code for the error */
  code: UpdateUserInfoErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateUserInfoErrorEnum {
  /** There was a problem while updating the user info */
  Generic = "GENERIC",
  /** User info not found */
  NotFound = "NOT_FOUND",
  /** You are not authorized to update this user info */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid user info data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateUserInfo. */
export type UpdateUserInfoPayload = {
  __typename?: "UpdateUserInfoPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateUserInfoError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated user */
  user?: Maybe<User>
  /** The updated user info */
  userInfo?: Maybe<UserInfo>
}

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: "UpdateUserPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UsersUpdateUserError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated user */
  user?: Maybe<User>
}

/** A generic error type for mutations */
export type UpdateVenueError = {
  __typename?: "UpdateVenueError"
  /** A machine-friendly code for the error */
  code: UpdateVenueErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateVenueErrorEnum {
  /** There was a problem while updating the venue */
  Generic = "GENERIC",
  /** You are not authorized to update this venue */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid venue data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** A generic error type for mutations */
export type UpdateVenueLayoutError = {
  __typename?: "UpdateVenueLayoutError"
  /** A machine-friendly code for the error */
  code: UpdateVenueLayoutErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateVenueLayoutErrorEnum {
  /** There was a problem while updating the venue layout */
  Generic = "GENERIC",
  /** You are not authorized to update the layout for this venue */
  Unauthorized = "UNAUTHORIZED",
  /** There was an issue with your request, please contact support if the problem persists */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateVenueLayout. */
export type UpdateVenueLayoutPayload = {
  __typename?: "UpdateVenueLayoutPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateVenueLayoutError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated table groups */
  tableGroups?: Maybe<Array<TableGroup>>
}

/** Autogenerated return type of UpdateVenue. */
export type UpdateVenuePayload = {
  __typename?: "UpdateVenuePayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateVenueError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated venue */
  venue?: Maybe<Venue>
}

/** A generic error type for mutations */
export type UpdateVenueTagsError = {
  __typename?: "UpdateVenueTagsError"
  /** A machine-friendly code for the error */
  code: UpdateVenueTagsErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateVenueTagsErrorEnum {
  /** There was a problem while updating venue tags */
  Generic = "GENERIC",
  /** You are not authorized to update venue tags */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid tag data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateVenueTags. */
export type UpdateVenueTagsPayload = {
  __typename?: "UpdateVenueTagsPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateVenueTagsError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated venue */
  venue?: Maybe<Venue>
}

/** A generic error type for mutations */
export type UpdateVenueWorkingHoursError = {
  __typename?: "UpdateVenueWorkingHoursError"
  /** A machine-friendly code for the error */
  code: UpdateVenueWorkingHoursErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UpdateVenueWorkingHoursErrorEnum {
  /** There was a problem while updating the working hours */
  Generic = "GENERIC",
  /** You are not authorized to update working hours for this venue */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid working hour data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** Autogenerated return type of UpdateVenueWorkingHours. */
export type UpdateVenueWorkingHoursPayload = {
  __typename?: "UpdateVenueWorkingHoursPayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UpdateVenueWorkingHoursError>>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
  /** The updated working hours */
  workingHours?: Maybe<Array<OpeningHour>>
}

/** A generic error type for mutations */
export type UploadImageError = {
  __typename?: "UploadImageError"
  /** A machine-friendly code for the error */
  code: UploadImageErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UploadImageErrorEnum {
  /** There was a problem while uploading the image */
  Generic = "GENERIC",
  /** You are not authorized to upload an image for this resource */
  Unauthorized = "UNAUTHORIZED",
}

/** Autogenerated return type of UploadImage. */
export type UploadImagePayload = {
  __typename?: "UploadImagePayload"
  /** An error returned if the mutation fails */
  errors?: Maybe<Array<UploadImageError>>
  /** The created image */
  image?: Maybe<Image>
  /** A flag indicating if the mutation was successful */
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** A user (usually employee or owner) that can log in to the area and manage a business or a single venue */
export type User = ActivityOwnerInterface &
  ActivityResourceInterface & {
    __typename?: "User"
    /** Avatar image of the user */
    avatar?: Maybe<Image>
    /** Avatar URL of the user (uses uploaded avatar or falls back to Gravatar) */
    avatarUrl?: Maybe<Scalars["String"]["output"]>
    /** Business that the user belongs to */
    business: Business
    /** Email of the user */
    email: Scalars["String"]["output"]
    /** First name of the user */
    firstName?: Maybe<Scalars["String"]["output"]>
    /** ID of the user */
    id: Scalars["ID"]["output"]
    /** Additional info about the user */
    info: UserInfo
    /** Last name of the user */
    lastName?: Maybe<Scalars["String"]["output"]>
    /** Full name of the customer */
    name: Scalars["String"]["output"]
    /** Roles assigned to the user */
    roles: Array<UserRole>
    /** Type of the activity owner */
    type?: Maybe<Scalars["String"]["output"]>
  }

/** A user (usually employee or owner) that can log in to the area and manage a business or a single venue */
export type UserRolesArgs = {
  venueSlug?: InputMaybe<Scalars["String"]["input"]>
}

/** UserCollection type */
export type UserCollection = {
  __typename?: "UserCollection"
  /** A collection of paginated UserCollection */
  collection: Array<User>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** The connection type for User. */
export type UserConnection = {
  __typename?: "UserConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** Total count of items in all pages. */
  totalCount: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type UserEdge = {
  __typename?: "UserEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<User>
}

/** Additional info about a user */
export type UserInfo = {
  __typename?: "UserInfo"
  /** Street address of the user */
  address?: Maybe<Scalars["String"]["output"]>
  /** City where the user lives */
  city?: Maybe<Scalars["String"]["output"]>
  /** Country of the user */
  country?: Maybe<Scalars["String"]["output"]>
  /** ID of the user info record */
  id: Scalars["ID"]["output"]
  /** Phone number of the user */
  phone?: Maybe<Scalars["String"]["output"]>
  /** Phone number formatted for display */
  phoneFormatted?: Maybe<Scalars["String"]["output"]>
  /** Position or job title of the user */
  position?: Maybe<Scalars["String"]["output"]>
  /** Postal/ZIP code of the user */
  postcode?: Maybe<Scalars["String"]["output"]>
}

/** A role assigned to a user for a specific venue */
export type UserRole = {
  __typename?: "UserRole"
  /** When the role was created */
  createdAt: Scalars["ISO8601DateTime"]["output"]
  /** ID of the user role */
  id: Scalars["ID"]["output"]
  /** The role name/type */
  role?: Maybe<Role>
  /** The user this role is assigned to */
  user: User
  /** The venue this role applies to */
  venue?: Maybe<Venue>
}

/** Input for assigning a role to a user for a specific venue */
export type UserRoleInput = {
  /** Role to assign */
  role: Role
  /** ID of the venue */
  venueId: Scalars["ID"]["input"]
}

/** Fields to sort users by */
export enum UserSortField {
  /** Sort by creation date */
  CreatedAt = "CREATED_AT",
  /** Sort by email */
  Email = "EMAIL",
  /** Sort by name */
  Name = "NAME",
}

/** A generic error type for mutations */
export type UsersCreateUserError = {
  __typename?: "UsersCreateUserError"
  /** A machine-friendly code for the error */
  code: UsersCreateUserErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UsersCreateUserErrorEnum {
  /** There was a problem while creating the user */
  Generic = "GENERIC",
  /** You are not authorized to create users */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid user data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** A generic error type for mutations */
export type UsersDeleteUserError = {
  __typename?: "UsersDeleteUserError"
  /** A machine-friendly code for the error */
  code: UsersDeleteUserErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UsersDeleteUserErrorEnum {
  /** You cannot delete yourself */
  CannotDeleteSelf = "CANNOT_DELETE_SELF",
  /** There was a problem while deleting the user */
  Generic = "GENERIC",
  /** User not found */
  NotFound = "NOT_FOUND",
  /** You are not authorized to delete this user */
  Unauthorized = "UNAUTHORIZED",
}

/** A generic error type for mutations */
export type UsersUpdateUserError = {
  __typename?: "UsersUpdateUserError"
  /** A machine-friendly code for the error */
  code: UsersUpdateUserErrorEnum
  /** A human-friendly message describing the error */
  message: Scalars["String"]["output"]
  /** The path to the field that caused the error */
  path?: Maybe<Array<Scalars["String"]["output"]>>
}

export enum UsersUpdateUserErrorEnum {
  /** Cannot remove admin role from the only admin user */
  CannotRemoveOnlyAdmin = "CANNOT_REMOVE_ONLY_ADMIN",
  /** There was a problem while updating the user */
  Generic = "GENERIC",
  /** User not found */
  NotFound = "NOT_FOUND",
  /** You are not authorized to update this user */
  Unauthorized = "UNAUTHORIZED",
  /** Invalid user data provided */
  ValidationError = "VALIDATION_ERROR",
}

/** A venue, a place where reservations can be made */
export type Venue = ActivityResourceInterface & {
  __typename?: "Venue"
  /** Activity log entries related to the venue */
  activities: ActivityCollection
  /** Business to which the venue belongs */
  business: Business
  /** ISO code of the country where venue is located */
  country: Scalars["String"]["output"]
  /** Default locale used for customer-facing venue flows */
  defaultLocale: Scalars["String"]["output"]
  /** ID of the venue */
  id: Scalars["ID"]["output"]
  /** Images associated with the venue */
  images: Array<Image>
  /** Additional information about the venue */
  info?: Maybe<VenueInfo>
  /** Name of the venue */
  name: Scalars["String"]["output"]
  /** Opening hours of the venue */
  openingHours: Array<OpeningHour>
  /** Permissions of the current user for the venue */
  permissions: VenuePermission
  /** Plan sections of the venue */
  plans: Array<VenuePlan>
  /** Reservation configuration for the venue */
  reservationConfiguration?: Maybe<ReservationConfiguration>
  /** Custom reservation rule sections for the venue */
  reservationRuleSections: Array<ReservationRuleSection>
  /** Reservations made at the venue */
  reservations: ReservationConnection
  /** Unique slug of the venue */
  slug: Scalars["String"]["output"]
  /** Table groups that belong to the venue */
  tableGroups: Array<TableGroup>
  /** Tables that belong to the venue */
  tables: Array<Table>
  /** Tags assigned to the venue */
  tags: Array<VenueTag>
  /** Timezone of the area where venue is located */
  timezone: Scalars["String"]["output"]
  /** Users that have access to the venue */
  users: UserConnection
}

/** A venue, a place where reservations can be made */
export type VenueActivitiesArgs = {
  includeRelated?: InputMaybe<Scalars["Boolean"]["input"]>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

/** A venue, a place where reservations can be made */
export type VenueImagesArgs = {
  kind?: InputMaybe<Array<ImageKind>>
}

/** A venue, a place where reservations can be made */
export type VenueReservationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  dateFilter?: InputMaybe<ReservationDateFilterInput>
  first?: InputMaybe<Scalars["Int"]["input"]>
  includeRemoved?: InputMaybe<Scalars["Boolean"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Array<ReservationStatus>>
  tableGroups?: InputMaybe<Array<Scalars["ID"]["input"]>>
  tables?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

/** A venue, a place where reservations can be made */
export type VenueTableGroupsArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A venue, a place where reservations can be made */
export type VenueTablesArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A venue, a place where reservations can be made */
export type VenueUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

/** Additional information about a venue */
export type VenueInfo = {
  __typename?: "VenueInfo"
  /** Street address of the venue */
  address?: Maybe<Scalars["String"]["output"]>
  /** City where the venue is located */
  city?: Maybe<Scalars["String"]["output"]>
  /** Description of the venue */
  description?: Maybe<Scalars["String"]["output"]>
  /** Contact email address */
  email?: Maybe<Scalars["String"]["output"]>
  /** ID of the venue info */
  id: Scalars["ID"]["output"]
  /** Latitude coordinate of the venue */
  latitude?: Maybe<Scalars["Float"]["output"]>
  /** Longitude coordinate of the venue */
  longitude?: Maybe<Scalars["Float"]["output"]>
  /** Contact phone number */
  phone?: Maybe<Scalars["String"]["output"]>
  /** Social media accounts */
  socialAccounts?: Maybe<Scalars["JSON"]["output"]>
  /** The venue this info belongs to */
  venue: Venue
  /** Website URL */
  website?: Maybe<Scalars["String"]["output"]>
  /** Postal/ZIP code of the venue */
  zipcode?: Maybe<Scalars["String"]["output"]>
}

/** Permissions for a staff member in a venue */
export type VenuePermission = {
  __typename?: "VenuePermission"
  /** Can access billing and payment settings */
  billing: Scalars["Boolean"]["output"]
  /** Can create new venues */
  createVenues: Scalars["Boolean"]["output"]
  /** Can create, update, and delete reservations */
  manageReservations: Scalars["Boolean"]["output"]
  /** Can manage users and their roles */
  manageUsers: Scalars["Boolean"]["output"]
  /** Can manage venue settings and configuration */
  manageVenue: Scalars["Boolean"]["output"]
  /** Can view activity log */
  viewActivityLog: Scalars["Boolean"]["output"]
  /** Can view clients and customer information */
  viewClients: Scalars["Boolean"]["output"]
  /** Can view reports and analytics */
  viewReports: Scalars["Boolean"]["output"]
  /** Can view reservations */
  viewReservations: Scalars["Boolean"]["output"]
}

/** A plan section for a venue */
export type VenuePlan = {
  __typename?: "VenuePlan"
  /** Whether this is the default plan for the venue */
  default: Scalars["Boolean"]["output"]
  /** ID of the venue plan */
  id: Scalars["ID"]["output"]
  /** SVG content of the plan */
  plan?: Maybe<Scalars["String"]["output"]>
  /** Position/order of the plan */
  position: Scalars["Int"]["output"]
  /** Name of the plan section */
  sectionName?: Maybe<Scalars["String"]["output"]>
}

/** Input for venue plan data */
export type VenuePlanInput = {
  /** Whether this is the default plan for the venue */
  default?: InputMaybe<Scalars["Boolean"]["input"]>
  /** ID of existing venue plan (null for new plans) */
  id?: InputMaybe<Scalars["ID"]["input"]>
  /** SVG content of the plan */
  plan?: InputMaybe<Scalars["String"]["input"]>
  /** Position/order of the plan */
  position: Scalars["Int"]["input"]
  /** Name of the plan section */
  sectionName: Scalars["String"]["input"]
}

/** A tag assigned to a venue */
export type VenueTag = {
  __typename?: "VenueTag"
  /** Tag category (e.g. "venue_type", "cuisine") */
  category: Scalars["String"]["output"]
  /** Whether this is a custom (user-added) value */
  custom: Scalars["Boolean"]["output"]
  /** i18n-resolved display label */
  label: Scalars["String"]["output"]
  /** Position within category for ordering */
  position: Scalars["Int"]["output"]
  /** Stored tag value */
  value: Scalars["String"]["output"]
}

/** Input for venue working hour */
export type VenueWorkingHourInput = {
  /** Whether the venue is closed */
  closed?: InputMaybe<Scalars["Boolean"]["input"]>
  /** End date for special hours */
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>
  /** Closing time */
  endTime?: InputMaybe<Scalars["String"]["input"]>
  /** ID of existing working hour (for updates) */
  id?: InputMaybe<Scalars["ID"]["input"]>
  /** Type of opening hours */
  kind: OpeningHourKind
  /** Start date for special hours */
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>
  /** Opening time */
  startTime?: InputMaybe<Scalars["String"]["input"]>
  /** Day of the week (0-6) */
  weekday?: InputMaybe<Scalars["Int"]["input"]>
}

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never }>

export type GetAppConfigQuery = {
  __typename?: "Query"
  appConfig: { __typename?: "AppConfig"; googleMapsApiKey?: string | null }
}

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type GetCurrentUserQuery = {
  __typename?: "Query"
  currentUser?: {
    __typename: "CurrentUser"
    id: string
    email: string
    avatarUrl?: string | null
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type GetCurrentUserRolesQueryVariables = Exact<{
  venueSlug?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetCurrentUserRolesQuery = {
  __typename?: "Query"
  currentUser?: {
    __typename?: "CurrentUser"
    id: string
    roles: Array<{
      __typename?: "UserRole"
      id: string
      role?: Role | null
      createdAt: any
      user: { __typename?: "User"; id: string; email: string }
      venue?: { __typename?: "Venue"; id: string; slug: string; name: string } | null
    }>
  } | null
}

export type GetCurrentUserWithInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetCurrentUserWithInfoQuery = {
  __typename?: "Query"
  currentUser?: {
    __typename?: "CurrentUser"
    id: string
    email: string
    avatarUrl?: string | null
    firstName?: string | null
    lastName?: string | null
    name: string
    avatar?: { __typename?: "Image"; id: string; url?: string | null } | null
    info?: {
      __typename?: "UserInfo"
      id: string
      address?: string | null
      city?: string | null
      country?: string | null
      phone?: string | null
      position?: string | null
      postcode?: string | null
    } | null
    roles: Array<{ __typename?: "UserRole"; id: string; role?: Role | null }>
  } | null
}

export type UpdatePasswordMutationVariables = Exact<{
  currentPassword: Scalars["String"]["input"]
  newPassword: Scalars["String"]["input"]
  newPasswordConfirmation: Scalars["String"]["input"]
}>

export type UpdatePasswordMutation = {
  __typename?: "Mutation"
  updatePassword?: {
    __typename?: "UpdatePasswordPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UpdatePasswordError"; code: UpdatePasswordErrorEnum; message: string }> | null
    user?: { __typename?: "User"; id: string; email: string } | null
  } | null
}

export type CreateCustomerNoteMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"]
  note: Scalars["String"]["input"]
}>

export type CreateCustomerNoteMutation = {
  __typename?: "Mutation"
  createCustomerNote?: {
    __typename?: "CreateCustomerNotePayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "CreateCustomerNoteError"
      code: CreateCustomerNoteErrorEnum
      message: string
    }> | null
  } | null
}

export type GetCustomerQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetCustomerQuery = {
  __typename?: "Query"
  business?: {
    __typename?: "Business"
    customer?: {
      __typename?: "Customer"
      id: string
      stats: {
        __typename?: "CustomerStats"
        reservations: {
          __typename?: "Reservations"
          cancelled: number
          noShow: number
          pending: number
          seated: number
          total: number
        }
      }
      customerContacts: Array<{
        __typename?: "CustomerContact"
        id: string
        name?: string | null
        email?: string | null
        avatarUrl?: string | null
        phoneFormatted?: string | null
      }>
    } | null
  } | null
}

export type GetCustomerActivitiesQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"]
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  after?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetCustomerActivitiesQuery = {
  __typename?: "Query"
  business?: {
    __typename?: "Business"
    customer?: {
      __typename?: "Customer"
      id: string
      activities: {
        __typename?: "ActivityConnection"
        totalCount: number
        pageInfo: {
          __typename?: "PageInfo"
          hasPreviousPage: boolean
          hasNextPage: boolean
          startCursor?: string | null
          endCursor?: string | null
        }
        nodes?: Array<{
          __typename?: "Activity"
          id: string
          key: string
          createdAt: any
          parameters?: any | null
          owner?:
            | { __typename?: "Customer"; id: string; type?: string | null }
            | {
                __typename?: "User"
                email: string
                avatarUrl?: string | null
                firstName?: string | null
                lastName?: string | null
                id: string
                type?: string | null
              }
            | null
        } | null> | null
      }
    } | null
  } | null
}

export type GetCustomerByContactQueryVariables = Exact<{
  customerContactId: Scalars["ID"]["input"]
}>

export type GetCustomerByContactQuery = {
  __typename?: "Query"
  business?: {
    __typename?: "Business"
    customer?: {
      __typename?: "Customer"
      id: string
      stats: {
        __typename?: "CustomerStats"
        reservations: {
          __typename?: "Reservations"
          cancelled: number
          noShow: number
          pending: number
          seated: number
          total: number
        }
      }
      customerContacts: Array<{
        __typename?: "CustomerContact"
        id: string
        name?: string | null
        email?: string | null
        phone?: string | null
        avatarUrl?: string | null
        phoneFormatted?: string | null
      }>
    } | null
  } | null
}

export type GetCustomerContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
  searchField?: InputMaybe<Scalars["String"]["input"]>
  sort?: InputMaybe<CustomerContactSort>
  sortDirection?: InputMaybe<SortDirection>
}>

export type GetCustomerContactsQuery = {
  __typename?: "Query"
  business?: {
    __typename?: "Business"
    customerContacts: {
      __typename?: "CustomerContactCollection"
      metadata: {
        __typename?: "CollectionMetadata"
        currentPage: number
        limitValue: number
        totalCount: number
        totalPages: number
      }
      collection: Array<{
        __typename?: "CustomerContact"
        id: string
        name?: string | null
        email?: string | null
        avatarUrl?: string | null
        phoneFormatted?: string | null
        customer?: {
          __typename?: "Customer"
          id: string
          stats: {
            __typename?: "CustomerStats"
            reservations: { __typename?: "Reservations"; noShow: number; cancelled: number; total: number }
          }
        } | null
      }>
    }
  } | null
}

export type GetCustomerNotesQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}>

export type GetCustomerNotesQuery = {
  __typename?: "Query"
  business?: {
    __typename?: "Business"
    customerNotes?: {
      __typename?: "CustomerNoteCollection"
      metadata: { __typename?: "CollectionMetadata"; currentPage: number; totalPages: number; totalCount: number }
      collection: Array<{
        __typename?: "CustomerNote"
        id: string
        note: string
        createdAt: any
        user: { __typename?: "User"; id: string; name: string; email: string; avatarUrl?: string | null }
      }>
    } | null
  } | null
}

export type GetCustomerReservationsQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}>

export type GetCustomerReservationsQuery = {
  __typename?: "Query"
  business?: {
    __typename?: "Business"
    customer?: {
      __typename?: "Customer"
      id: string
      reservations: {
        __typename?: "ReservationCollection"
        metadata: { __typename?: "CollectionMetadata"; currentPage: number; totalPages: number; totalCount: number }
        collection: Array<{
          __typename?: "Reservation"
          id: string
          startTime: any
          endTime: any
          peopleAmount?: number | null
          status: ReservationStatus
          customerNote?: string | null
          venue: { __typename?: "Venue"; id: string; name: string }
          table: {
            __typename?: "Table"
            id: string
            name: string
            tableGroup: { __typename?: "TableGroup"; id: string; name: string }
          }
        }>
      }
    } | null
  } | null
}

export type UpdateCustomerContactMutationVariables = Exact<{
  customerContactId: Scalars["ID"]["input"]
  name: Scalars["String"]["input"]
  email?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateCustomerContactMutation = {
  __typename?: "Mutation"
  updateCustomerContact?: {
    __typename?: "UpdateCustomerContactPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "UpdateCustomerContactError"
      code: UpdateCustomerContactErrorEnum
      message: string
    }> | null
    customerContact?: {
      __typename?: "CustomerContact"
      id: string
      name?: string | null
      email?: string | null
      phone?: string | null
      phoneFormatted?: string | null
      avatarUrl?: string | null
    } | null
  } | null
}

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>

export type GetFeatureFlagsQuery = {
  __typename?: "Query"
  featureFlags: { __typename?: "FeatureFlags"; customSectionsEnabled: boolean }
}

export type GeocodeAddressQueryVariables = Exact<{
  address: Scalars["String"]["input"]
}>

export type GeocodeAddressQuery = {
  __typename?: "Query"
  geocodeAddress?: { __typename?: "Geocoordinates"; latitude: number; longitude: number } | null
}

export type RemoveImageMutationVariables = Exact<{
  imageId: Scalars["ID"]["input"]
  associatedId: Scalars["ID"]["input"]
  associatedType: Associated
}>

export type RemoveImageMutation = {
  __typename?: "Mutation"
  removeImage?: {
    __typename?: "RemoveImagePayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "RemoveImageError"; code: RemoveImageErrorEnum; message: string }> | null
  } | null
}

export type CompleteOauthSignupMutationVariables = Exact<{
  phone: Scalars["String"]["input"]
  businessName: Scalars["String"]["input"]
  country: Country
  timezone?: InputMaybe<Scalars["String"]["input"]>
}>

export type CompleteOauthSignupMutation = {
  __typename?: "Mutation"
  completeOauthSignup: {
    __typename?: "CompleteOauthSignupPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "CompleteOauthSignupError"
      code: CompleteOauthSignupErrorEnum
      message: string
      path?: Array<string> | null
    }> | null
    user?: {
      __typename?: "CurrentUser"
      id: string
      email: string
      avatarUrl?: string | null
      firstName?: string | null
      lastName?: string | null
    } | null
  }
}

export type GetOAuthProvidersQueryVariables = Exact<{ [key: string]: never }>

export type GetOAuthProvidersQuery = {
  __typename?: "Query"
  oauthProviders: { __typename?: "OauthProviders"; googleEnabled: boolean; facebookEnabled: boolean }
}

export type GetOAuthSignupDataQueryVariables = Exact<{ [key: string]: never }>

export type GetOAuthSignupDataQuery = {
  __typename?: "Query"
  oauthSignupData?: {
    __typename?: "OauthSignupData"
    email: string
    firstName?: string | null
    lastName?: string | null
    provider: string
  } | null
}

export type CreateAccountMutationVariables = Exact<{
  businessName: Scalars["String"]["input"]
  country: Country
  email: Scalars["String"]["input"]
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
  phone: Scalars["String"]["input"]
  timezone?: InputMaybe<Scalars["String"]["input"]>
}>

export type CreateAccountMutation = {
  __typename?: "Mutation"
  createAccount: {
    __typename?: "CreateAccountPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "CreateAccountError"
      code: CreateAccountErrorEnum
      message: string
      path?: Array<string> | null
    }> | null
  }
}

export type GetPublicBusyBlocksQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  tableId: Scalars["ID"]["input"]
  date: Scalars["ISO8601Date"]["input"]
  excludeReservationId?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetPublicBusyBlocksQuery = {
  __typename?: "Query"
  public: {
    __typename?: "Public"
    venue?: {
      __typename?: "PublicVenue"
      busyBlocks: Array<{ __typename?: "PublicBusyBlock"; startTime: any; endTime: any }>
    } | null
  }
}

export type GetPublicReservationQueryVariables = Exact<{
  uuid: Scalars["ID"]["input"]
}>

export type GetPublicReservationQuery = {
  __typename?: "Query"
  public: {
    __typename?: "Public"
    reservation?: {
      __typename?: "PublicReservation"
      email?: string | null
      locale: string
      name?: string | null
      phone?: string | null
      peopleAmount?: number | null
      startTime: any
      endTime: any
      tableId: string
      tableName: string
      venueName: string
      status: PublicReservationStatus
      canCancel: boolean
      canStartCancellation: boolean
      cancellationDeadlineAt?: any | null
      customerNote?: string | null
      referenceNumber: string
      timezone: string
      venue: {
        __typename?: "PublicVenue"
        name: string
        slug: string
        timezone: string
        images: Array<{ __typename?: "PublicImage"; id: string; url?: string | null; kind: string }>
        info?: {
          __typename?: "PublicVenueInfo"
          phone?: string | null
          phoneFormatted?: string | null
          email?: string | null
          address?: string | null
          city?: string | null
          latitude?: number | null
          longitude?: number | null
        } | null
        reservationConfiguration?: {
          __typename?: "PublicReservationConfiguration"
          availableBookingPolicyTiles: Array<PublicBookingPolicyTile>
          bookingPolicyTiles: Array<PublicBookingPolicyTile>
          cancellationDeadline?: number | null
          largeGroupThreshold?: number | null
          maxReservationTime?: number | null
          minReservationTime?: number | null
          noshowAutoCancelAfter?: number | null
        } | null
        reservationRuleSections: Array<{
          __typename?: "PublicReservationRuleSection"
          id: string
          identifier: string
          position: number
          title: string
          content?: string | null
        }>
        tableGroups: Array<{ __typename?: "PublicTableGroup"; name: string }>
      }
    } | null
  }
}

export type GetPublicTableBusyBlocksByDateQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  date: Scalars["ISO8601Date"]["input"]
}>

export type GetPublicTableBusyBlocksByDateQuery = {
  __typename?: "Query"
  public: {
    __typename?: "Public"
    venue?: {
      __typename?: "PublicVenue"
      tableBusyBlocksByDate: Array<{
        __typename?: "PublicTableBusyBlock"
        tableId: string
        startTime: any
        endTime: any
      }>
    } | null
  }
}

export type PublicVenueQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
}>

export type PublicVenueQuery = {
  __typename?: "Query"
  public: {
    __typename?: "Public"
    venue?: {
      __typename?: "PublicVenue"
      slug: string
      name: string
      country: string
      defaultLocale: string
      timezone: string
      info?: {
        __typename?: "PublicVenueInfo"
        address?: string | null
        city?: string | null
        zipcode?: string | null
        description?: string | null
        phone?: string | null
        email?: string | null
        website?: string | null
        socialAccounts?: any | null
        latitude?: number | null
        longitude?: number | null
      } | null
      images: Array<{ __typename?: "PublicImage"; id: string; kind: string; url?: string | null }>
      openingHours: Array<{
        __typename?: "PublicOpeningHour"
        id: string
        closed?: boolean | null
        endDate?: any | null
        endTime?: string | null
        kind?: OpeningHourKind | null
        startDate?: any | null
        startTime?: string | null
        weekday?: number | null
      }>
      reservationConfiguration?: {
        __typename?: "PublicReservationConfiguration"
        availableBookingPolicyTiles: Array<PublicBookingPolicyTile>
        bookingPolicyTiles: Array<PublicBookingPolicyTile>
        maxAdvanceBookingTime?: number | null
        minAdvanceBookingTime?: number | null
        minReservationTime?: number | null
        maxReservationTime?: number | null
        reservationBuffer?: number | null
        noshowAutoCancelAfter?: number | null
        cancellationDeadline?: number | null
        largeGroupThreshold?: number | null
      } | null
      reservationRuleSections: Array<{
        __typename?: "PublicReservationRuleSection"
        id: string
        identifier: string
        title: string
        content?: string | null
        position: number
      }>
      tableGroups: Array<{ __typename?: "PublicTableGroup"; id: string; name: string }>
      tables: Array<{
        __typename?: "PublicTable"
        id: string
        name: string
        minCapacity?: number | null
        maxCapacity?: number | null
        tableGroup: { __typename?: "PublicTableGroup"; id: string; name: string }
      }>
      plans: Array<{
        __typename?: "PublicVenuePlan"
        id: string
        sectionName?: string | null
        plan?: string | null
        position: number
        default: boolean
      }>
      tags: Array<{
        __typename?: "VenueTag"
        category: string
        value: string
        label: string
        position: number
        custom: boolean
      }>
    } | null
  }
}

export type IsVenueOpenQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  startTime: Scalars["ISO8601DateTime"]["input"]
  endTime: Scalars["ISO8601DateTime"]["input"]
}>

export type IsVenueOpenQuery = {
  __typename?: "Query"
  public: { __typename?: "Public"; venue?: { __typename?: "PublicVenue"; open: boolean } | null }
}

export type PublicCancelReservationMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"]
  token: Scalars["String"]["input"]
}>

export type PublicCancelReservationMutation = {
  __typename?: "Mutation"
  publicCancelReservation: {
    __typename?: "PublicCancelReservationPayload"
    success?: boolean | null
    reservation?: {
      __typename?: "PublicReservation"
      id: string
      status: PublicReservationStatus
      canCancel: boolean
      canStartCancellation: boolean
    } | null
    errors?: Array<{
      __typename?: "PublicCancelReservationError"
      code: PublicCancelReservationErrorEnum
      message: string
    }> | null
  }
}

export type PublicConfirmReservationMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"]
  token: Scalars["String"]["input"]
}>

export type PublicConfirmReservationMutation = {
  __typename?: "Mutation"
  publicConfirmReservation: {
    __typename?: "PublicConfirmReservationPayload"
    reservation?: { __typename?: "PublicReservation"; id: string; status: PublicReservationStatus } | null
    errors?: Array<{
      __typename?: "PublicConfirmReservationError"
      code: PublicConfirmReservationErrorEnum
      message: string
    }> | null
  }
}

export type PublicCreateReservationMutationVariables = Exact<{
  venue: Scalars["String"]["input"]
  customer: PublicCustomerInput
  endTime: Scalars["ISO8601DateTime"]["input"]
  locale?: InputMaybe<Scalars["String"]["input"]>
  peopleAmount: Scalars["Int"]["input"]
  startTime: Scalars["ISO8601DateTime"]["input"]
  tableId: Scalars["String"]["input"]
  note?: InputMaybe<Scalars["String"]["input"]>
}>

export type PublicCreateReservationMutation = {
  __typename?: "Mutation"
  publicCreateReservation: {
    __typename?: "PublicCreateReservationPayload"
    confirmUntil?: any | null
    resendAvailableAt?: any | null
    resendsRemaining?: number | null
    reservation?: { __typename?: "PublicReservation"; id: string } | null
    errors?: Array<{
      __typename?: "PublicCreateReservationError"
      code: PublicCreateReservationErrorEnum
      message: string
    }> | null
  }
}

export type PublicModifyReservationMutationVariables = Exact<{
  originalReservationId: Scalars["ID"]["input"]
  venue: Scalars["String"]["input"]
  customer: PublicCustomerInput
  endTime: Scalars["ISO8601DateTime"]["input"]
  locale?: InputMaybe<Scalars["String"]["input"]>
  peopleAmount: Scalars["Int"]["input"]
  startTime: Scalars["ISO8601DateTime"]["input"]
  tableId: Scalars["String"]["input"]
  note?: InputMaybe<Scalars["String"]["input"]>
  token: Scalars["String"]["input"]
}>

export type PublicModifyReservationMutation = {
  __typename?: "Mutation"
  publicModifyReservation: {
    __typename?: "PublicModifyReservationPayload"
    confirmUntil?: any | null
    resendAvailableAt?: any | null
    resendsRemaining?: number | null
    reservation?: { __typename?: "PublicReservation"; id: string } | null
    errors?: Array<{
      __typename?: "PublicModifyReservationError"
      code: PublicModifyReservationErrorEnum
      message: string
    }> | null
  }
}

export type PublicResendReservationConfirmationMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"]
  token?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
}>

export type PublicResendReservationConfirmationMutation = {
  __typename?: "Mutation"
  publicResendReservationConfirmation: {
    __typename?: "PublicResendReservationConfirmationPayload"
    confirmUntil?: any | null
    resendAvailableAt?: any | null
    resendsRemaining?: number | null
    reservation?: { __typename?: "PublicReservation"; id: string; confirmUntil?: any | null } | null
    errors?: Array<{
      __typename?: "PublicResendReservationConfirmationError"
      code: PublicResendReservationConfirmationErrorEnum
      message: string
    }> | null
  }
}

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars["String"]["input"]
}>

export type RequestPasswordResetMutation = {
  __typename?: "Mutation"
  publicRequestPasswordReset: {
    __typename?: "PublicRequestPasswordResetPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "PublicRequestPasswordResetError"
      code: PublicRequestPasswordResetErrorEnum
      message: string
    }> | null
  }
}

export type CreateReservationMutationVariables = Exact<{
  customer: CustomerInput
  venueId: Scalars["ID"]["input"]
  peopleAmount?: InputMaybe<Scalars["Int"]["input"]>
  tableSlots: Array<TableSlotInput> | TableSlotInput
  status?: InputMaybe<Scalars["String"]["input"]>
  notes?: InputMaybe<Array<ReservationNoteInput> | ReservationNoteInput>
}>

export type CreateReservationMutation = {
  __typename?: "Mutation"
  createReservation?: {
    __typename?: "CreateReservationPayload"
    success?: boolean | null
    reservations?: Array<{
      __typename?: "Reservation"
      id: string
      startTime: any
      endTime: any
      peopleAmount?: number | null
      status: ReservationStatus
      customerNote?: string | null
      table: { __typename?: "Table"; id: string; name: string }
      venue: { __typename?: "Venue"; id: string; name: string }
      customer?: {
        __typename?: "Customer"
        id: string
        customerContacts: Array<{
          __typename?: "CustomerContact"
          id: string
          phone?: string | null
          email?: string | null
        }>
      } | null
    }> | null
    errors?: Array<{ __typename?: "CreateReservationError"; code: CreateReservationErrorEnum; message: string }> | null
  } | null
}

export type CreateReservationNoteMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"]
  note: Scalars["String"]["input"]
}>

export type CreateReservationNoteMutation = {
  __typename?: "Mutation"
  createReservationNote?: {
    __typename?: "CreateReservationNotePayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "CreateReservationNoteError"
      code: CreateReservationNoteErrorEnum
      message: string
    }> | null
  } | null
}

export type GetReservationQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  reservationId: Scalars["ID"]["input"]
}>

export type GetReservationQuery = {
  __typename?: "Query"
  reservation?: {
    __typename?: "Reservation"
    id: string
    startTime: any
    endTime: any
    peopleAmount?: number | null
    status: ReservationStatus
    customerNote?: string | null
    table: {
      __typename?: "Table"
      id: string
      name: string
      deleted: boolean
      tableGroup: { __typename?: "TableGroup"; id: string; name: string }
    }
    customer?: {
      __typename?: "Customer"
      id: string
      stats: {
        __typename?: "CustomerStats"
        reservations: {
          __typename?: "Reservations"
          pending: number
          seated: number
          noShow: number
          cancelled: number
          total: number
        }
      }
    } | null
    customerContact?: {
      __typename?: "CustomerContact"
      id: string
      name?: string | null
      email?: string | null
      phone?: string | null
      phoneFormatted?: string | null
      avatarUrl?: string | null
    } | null
    notes: { __typename?: "ReservationNoteConnection"; totalCount: number }
  } | null
  venue?: {
    __typename?: "Venue"
    plans: Array<{
      __typename?: "VenuePlan"
      id: string
      sectionName?: string | null
      plan?: string | null
      position: number
      default: boolean
    }>
    reservationConfiguration?: { __typename?: "ReservationConfiguration"; reservationBuffer?: number | null } | null
  } | null
}

export type GetReservationActivitiesQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  reservationId: Scalars["ID"]["input"]
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  after?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetReservationActivitiesQuery = {
  __typename?: "Query"
  reservation?: {
    __typename?: "Reservation"
    id: string
    activities: {
      __typename?: "ActivityConnection"
      totalCount: number
      pageInfo: {
        __typename?: "PageInfo"
        hasPreviousPage: boolean
        hasNextPage: boolean
        startCursor?: string | null
        endCursor?: string | null
      }
      nodes?: Array<{
        __typename?: "Activity"
        id: string
        key: string
        createdAt: any
        parameters?: any | null
        owner?:
          | { __typename?: "Customer"; id: string; type?: string | null }
          | {
              __typename?: "User"
              email: string
              avatarUrl?: string | null
              firstName?: string | null
              lastName?: string | null
              id: string
              type?: string | null
            }
          | null
      } | null> | null
    }
  } | null
}

export type GetReservationNotesQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  reservationId: Scalars["ID"]["input"]
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  after?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetReservationNotesQuery = {
  __typename?: "Query"
  reservation?: {
    __typename?: "Reservation"
    id: string
    notes: {
      __typename?: "ReservationNoteConnection"
      totalCount: number
      pageInfo: {
        __typename?: "PageInfo"
        hasPreviousPage: boolean
        hasNextPage: boolean
        startCursor?: string | null
        endCursor?: string | null
      }
      nodes?: Array<{
        __typename?: "ReservationNote"
        id: string
        note: string
        source: ReservationNoteSource
        name?: string | null
        avatarUrl?: string | null
        createdAt: any
      } | null> | null
    }
  } | null
}

export type GetReservationsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
  dateFilter?: InputMaybe<ReservationDateFilterInput>
  status?: InputMaybe<Array<ReservationStatus> | ReservationStatus>
  includeRemoved?: InputMaybe<Scalars["Boolean"]["input"]>
  tableGroups?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type GetReservationsQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    reservations: {
      __typename?: "ReservationConnection"
      nodes?: Array<{
        __typename?: "Reservation"
        id: string
        startTime: any
        endTime: any
        peopleAmount?: number | null
        status: ReservationStatus
        customerNote?: string | null
        table: {
          __typename?: "Table"
          id: string
          name: string
          deleted: boolean
          tableGroup: { __typename?: "TableGroup"; id: string; name: string }
        }
        customer?: { __typename?: "Customer"; id: string } | null
        customerContact?: {
          __typename?: "CustomerContact"
          name?: string | null
          email?: string | null
          phone?: string | null
          phoneFormatted?: string | null
          avatarUrl?: string | null
        } | null
      } | null> | null
    }
  } | null
}

export type RemoveReservationMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"]
}>

export type RemoveReservationMutation = {
  __typename?: "Mutation"
  removeReservation?: { __typename?: "RemoveReservationPayload"; success?: boolean | null } | null
}

export type UpdateReservationMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"]
  tableId?: InputMaybe<Scalars["String"]["input"]>
  startTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>
  endTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>
  peopleAmount?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<ReservationStatus>
  customerName?: InputMaybe<Scalars["String"]["input"]>
  customerEmail?: InputMaybe<Scalars["String"]["input"]>
  customerPhone?: InputMaybe<Scalars["String"]["input"]>
  customerContactId?: InputMaybe<Scalars["ID"]["input"]>
  updateAllContacts?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateReservationMutation = {
  __typename?: "Mutation"
  updateReservation?: {
    __typename?: "UpdateReservationPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UpdateReservationError"; code: UpdateReservationErrorEnum; message: string }> | null
  } | null
}

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
  passwordConfirmation: Scalars["String"]["input"]
}>

export type ResetPasswordMutation = {
  __typename?: "Mutation"
  publicResetPassword: {
    __typename?: "PublicResetPasswordPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "PublicResetPasswordError"
      code: PublicResetPasswordErrorEnum
      message: string
      path?: Array<string> | null
    }> | null
  }
}

export type UploadImageMutationVariables = Exact<{
  image: Scalars["Upload"]["input"]
  kind: ImageKind
  associatedId: Scalars["ID"]["input"]
  associatedType: Associated
}>

export type UploadImageMutation = {
  __typename?: "Mutation"
  uploadImage?: {
    __typename?: "UploadImagePayload"
    success?: boolean | null
    image?: {
      __typename?: "Image"
      id: string
      kind: string
      url?: string | null
      createdAt: any
      updatedAt: any
    } | null
    errors?: Array<{ __typename?: "UploadImageError"; code: UploadImageErrorEnum; message: string }> | null
  } | null
}

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  email: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
  passwordConfirmation: Scalars["String"]["input"]
  address?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  position?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  roles?: InputMaybe<Array<UserRoleInput> | UserRoleInput>
}>

export type CreateUserMutation = {
  __typename?: "Mutation"
  createUser?: {
    __typename?: "CreateUserPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UsersCreateUserError"; code: UsersCreateUserErrorEnum; message: string }> | null
    user?: {
      __typename?: "User"
      id: string
      firstName?: string | null
      lastName?: string | null
      email: string
      avatarUrl?: string | null
      roles: Array<{ __typename?: "UserRole"; id: string; role?: Role | null }>
    } | null
  } | null
}

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars["ID"]["input"]
}>

export type DeleteUserMutation = {
  __typename?: "Mutation"
  deleteUser?: {
    __typename?: "DeleteUserPayload"
    success?: boolean | null
    deletedUserId?: string | null
    errors?: Array<{ __typename?: "UsersDeleteUserError"; code: UsersDeleteUserErrorEnum; message: string }> | null
  } | null
}

export type GetUsersQueryVariables = Exact<{
  sortBy?: InputMaybe<UserSortField>
  sortDirection?: InputMaybe<SortDirection>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}>

export type GetUsersQuery = {
  __typename?: "Query"
  users?: {
    __typename?: "UserCollection"
    metadata: {
      __typename?: "CollectionMetadata"
      currentPage: number
      totalPages: number
      totalCount: number
      limitValue: number
    }
    collection: Array<{
      __typename?: "User"
      id: string
      firstName?: string | null
      lastName?: string | null
      name: string
      email: string
      avatarUrl?: string | null
      avatar?: { __typename?: "Image"; id: string; url?: string | null } | null
      info: {
        __typename?: "UserInfo"
        id: string
        address?: string | null
        city?: string | null
        country?: string | null
        phone?: string | null
        position?: string | null
        postcode?: string | null
      }
      roles: Array<{
        __typename?: "UserRole"
        id: string
        role?: Role | null
        venue?: { __typename?: "Venue"; id: string; name: string; slug: string } | null
      }>
    }>
  } | null
}

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars["ID"]["input"]
  firstName?: InputMaybe<Scalars["String"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  address?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  position?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  avatar?: InputMaybe<Scalars["Upload"]["input"]>
  removeAvatar?: InputMaybe<Scalars["Boolean"]["input"]>
  roles?: InputMaybe<Array<UserRoleInput> | UserRoleInput>
}>

export type UpdateUserMutation = {
  __typename?: "Mutation"
  updateUser?: {
    __typename?: "UpdateUserPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UsersUpdateUserError"; code: UsersUpdateUserErrorEnum; message: string }> | null
    user?: {
      __typename?: "User"
      id: string
      firstName?: string | null
      lastName?: string | null
      email: string
      avatarUrl?: string | null
      avatar?: { __typename?: "Image"; id: string; url?: string | null } | null
      roles: Array<{ __typename?: "UserRole"; id: string; role?: Role | null }>
    } | null
  } | null
}

export type UpdateUserInfoMutationVariables = Exact<{
  userId: Scalars["ID"]["input"]
  firstName?: InputMaybe<Scalars["String"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  address?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  position?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  avatar?: InputMaybe<Scalars["Upload"]["input"]>
  removeAvatar?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateUserInfoMutation = {
  __typename?: "Mutation"
  updateUserInfo?: {
    __typename?: "UpdateUserInfoPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UpdateUserInfoError"; code: UpdateUserInfoErrorEnum; message: string }> | null
    userInfo?: {
      __typename?: "UserInfo"
      id: string
      address?: string | null
      city?: string | null
      country?: string | null
      phone?: string | null
      phoneFormatted?: string | null
      position?: string | null
      postcode?: string | null
    } | null
    user?: {
      __typename?: "User"
      id: string
      firstName?: string | null
      lastName?: string | null
      avatarUrl?: string | null
      avatar?: { __typename?: "Image"; id: string; url?: string | null } | null
    } | null
  } | null
}

export type CountFutureReservationsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
  tableIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
  tableGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
  dateFilter?: InputMaybe<ReservationDateFilterInput>
}>

export type CountFutureReservationsQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    reservations: { __typename?: "ReservationConnection"; totalCount: number }
  } | null
}

export type CreateVenueMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  country: Scalars["String"]["input"]
  timezone: Scalars["String"]["input"]
}>

export type CreateVenueMutation = {
  __typename?: "Mutation"
  createVenue?: {
    __typename?: "CreateVenuePayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "CreateVenueError"; code: CreateVenueErrorEnum; message: string }> | null
    venue?: { __typename?: "Venue"; id: string; slug: string; name: string; country: string; timezone: string } | null
  } | null
}

export type GetOpeningHoursQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetOpeningHoursQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    slug: string
    name: string
    openingHours: Array<{
      __typename?: "OpeningHour"
      id: string
      closed?: boolean | null
      endDate?: any | null
      endTime?: string | null
      kind?: OpeningHourKind | null
      startDate?: any | null
      startTime?: string | null
      weekday?: number | null
    }>
    permissions: { __typename?: "VenuePermission"; manageVenue: boolean }
  } | null
}

export type GetTagDefinitionsQueryVariables = Exact<{ [key: string]: never }>

export type GetTagDefinitionsQuery = {
  __typename?: "Query"
  tagDefinitions: Array<{
    __typename?: "TagCategoryDefinition"
    key: string
    selectionType: string
    maxSelections?: number | null
    allowCustom: boolean
    label: string
    descriptionText?: string | null
    options: Array<{ __typename?: "TagOption"; value: string; label: string; subcategory?: string | null }>
  }>
}

export type GetVenueQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type GetVenueQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    slug: string
    name: string
    timezone: string
    country: string
    tableGroups: Array<{
      __typename?: "TableGroup"
      id: string
      name: string
      deleted: boolean
      tables: Array<{ __typename?: "Table"; id: string; name: string; deleted: boolean }>
    }>
    tables: Array<{
      __typename?: "Table"
      id: string
      name: string
      deleted: boolean
      tableGroup: { __typename?: "TableGroup"; id: string; name: string }
    }>
    reservationConfiguration?: {
      __typename?: "ReservationConfiguration"
      minReservationTime?: number | null
      maxReservationTime?: number | null
    } | null
    images: Array<{ __typename?: "Image"; id: string; url?: string | null; kind: string }>
    permissions: {
      __typename?: "VenuePermission"
      viewReservations: boolean
      manageReservations: boolean
      viewActivityLog: boolean
      viewClients: boolean
      manageVenue: boolean
      viewReports: boolean
      createVenues: boolean
      manageUsers: boolean
      billing: boolean
    }
  } | null
  venues?: Array<{
    __typename?: "Venue"
    id: string
    name: string
    slug: string
    permissions: {
      __typename?: "VenuePermission"
      viewReservations: boolean
      manageReservations: boolean
      viewActivityLog: boolean
      viewClients: boolean
      manageVenue: boolean
      viewReports: boolean
      createVenues: boolean
      manageUsers: boolean
      billing: boolean
    }
  }> | null
}

export type GetVenueActivitiesQueryVariables = Exact<{
  slug: Scalars["ID"]["input"]
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  includeRelated?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type GetVenueActivitiesQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    slug: string
    name: string
    activities: {
      __typename?: "ActivityCollection"
      metadata: { __typename?: "CollectionMetadata"; currentPage: number; totalPages: number; totalCount: number }
      collection: Array<{
        __typename?: "Activity"
        id: string
        key: string
        createdAt: any
        parameters?: any | null
        owner?:
          | { __typename: "Customer" }
          | {
              __typename: "User"
              id: string
              firstName?: string | null
              lastName?: string | null
              avatarUrl?: string | null
            }
          | null
        resource?:
          | {
              __typename: "Customer"
              id: string
              customerContacts: Array<{ __typename?: "CustomerContact"; id: string; name?: string | null }>
            }
          | { __typename: "Reservation"; id: string }
          | { __typename: "User"; id: string; firstName?: string | null; lastName?: string | null }
          | { __typename: "Venue"; id: string; name: string; slug: string }
          | null
      }>
    }
  } | null
}

export type GetVenueFullQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetVenueFullQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    slug: string
    name: string
    timezone: string
    country: string
    tableGroups: Array<{ __typename?: "TableGroup"; id: string; name: string; deleted: boolean }>
    tables: Array<{
      __typename?: "Table"
      id: string
      name: string
      minCapacity?: number | null
      maxCapacity?: number | null
      deleted: boolean
      tableGroup: { __typename?: "TableGroup"; id: string }
    }>
    plans: Array<{
      __typename?: "VenuePlan"
      id: string
      sectionName?: string | null
      plan?: string | null
      position: number
      default: boolean
    }>
    images: Array<{ __typename?: "Image"; id: string; url?: string | null; kind: string }>
    info?: {
      __typename?: "VenueInfo"
      id: string
      address?: string | null
      city?: string | null
      zipcode?: string | null
      phone?: string | null
      email?: string | null
      website?: string | null
      description?: string | null
      socialAccounts?: any | null
      latitude?: number | null
      longitude?: number | null
    } | null
    permissions: { __typename?: "VenuePermission"; manageVenue: boolean }
    reservationConfiguration?: { __typename?: "ReservationConfiguration"; reservationBuffer?: number | null } | null
    reservationRuleSections: Array<{
      __typename?: "ReservationRuleSection"
      id: string
      identifier: string
      title: string
      content?: string | null
      position: number
    }>
    tags: Array<{
      __typename?: "VenueTag"
      category: string
      value: string
      label: string
      position: number
      custom: boolean
    }>
  } | null
  venues?: Array<{ __typename?: "Venue"; id: string; name: string; slug: string }> | null
}

export type GetVenueInfoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetVenueInfoQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    slug: string
    name: string
    info?: {
      __typename?: "VenueInfo"
      id: string
      address?: string | null
      city?: string | null
      zipcode?: string | null
      phone?: string | null
      email?: string | null
      website?: string | null
      description?: string | null
      socialAccounts?: any | null
      latitude?: number | null
      longitude?: number | null
    } | null
  } | null
}

export type GetVenueReservationConfigurationQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetVenueReservationConfigurationQuery = {
  __typename?: "Query"
  venue?: {
    __typename?: "Venue"
    id: string
    info?: { __typename?: "VenueInfo"; phone?: string | null; email?: string | null } | null
    reservationConfiguration?: {
      __typename?: "ReservationConfiguration"
      availableBookingPolicyTiles: Array<BookingPolicyTile>
      bookingPolicyTiles: Array<BookingPolicyTile>
      id: string
      minAdvanceBookingTime?: number | null
      maxAdvanceBookingTime?: number | null
      minReservationTime?: number | null
      maxReservationTime?: number | null
      reservationBuffer?: number | null
      noshowAutoCancelAfter?: number | null
      cancellationDeadline?: number | null
      largeGroupThreshold?: number | null
    } | null
    tableGroups: Array<{ __typename?: "TableGroup"; id: string; name: string }>
    reservationRuleSections: Array<{
      __typename?: "ReservationRuleSection"
      id: string
      identifier: string
      title: string
      content?: string | null
      position: number
    }>
    permissions: { __typename?: "VenuePermission"; manageVenue: boolean }
  } | null
}

export type GetVenuesQueryVariables = Exact<{ [key: string]: never }>

export type GetVenuesQuery = {
  __typename?: "Query"
  venues?: Array<{
    __typename?: "Venue"
    id: string
    name: string
    slug: string
    permissions: {
      __typename?: "VenuePermission"
      viewReservations: boolean
      manageReservations: boolean
      viewActivityLog: boolean
      viewClients: boolean
      manageVenue: boolean
      viewReports: boolean
      createVenues: boolean
      manageUsers: boolean
      billing: boolean
    }
  }> | null
}

export type UpdateReservationConfigurationMutationVariables = Exact<{
  venueId: Scalars["ID"]["input"]
  minAdvanceBookingTime?: InputMaybe<Scalars["Int"]["input"]>
  maxAdvanceBookingTime?: InputMaybe<Scalars["Int"]["input"]>
  minReservationTime?: InputMaybe<Scalars["Int"]["input"]>
  maxReservationTime?: InputMaybe<Scalars["Int"]["input"]>
  reservationBuffer?: InputMaybe<Scalars["Int"]["input"]>
  noshowAutoCancelAfter?: InputMaybe<Scalars["Int"]["input"]>
  cancellationDeadline?: InputMaybe<Scalars["Int"]["input"]>
  largeGroupThreshold?: InputMaybe<Scalars["Int"]["input"]>
  bookingPolicyTiles?: InputMaybe<Array<BookingPolicyTile> | BookingPolicyTile>
}>

export type UpdateReservationConfigurationMutation = {
  __typename?: "Mutation"
  updateReservationConfiguration?: {
    __typename?: "UpdateReservationConfigurationPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "UpdateReservationConfigurationError"
      code: UpdateReservationConfigurationErrorEnum
      message: string
    }> | null
    reservationConfiguration?: {
      __typename?: "ReservationConfiguration"
      availableBookingPolicyTiles: Array<BookingPolicyTile>
      bookingPolicyTiles: Array<BookingPolicyTile>
      id: string
      minAdvanceBookingTime?: number | null
      maxAdvanceBookingTime?: number | null
      minReservationTime?: number | null
      maxReservationTime?: number | null
      reservationBuffer?: number | null
      noshowAutoCancelAfter?: number | null
      cancellationDeadline?: number | null
      largeGroupThreshold?: number | null
    } | null
  } | null
}

export type UpdateReservationRuleSectionsMutationVariables = Exact<{
  venueId: Scalars["ID"]["input"]
  sections: Array<ReservationRuleSectionInput> | ReservationRuleSectionInput
}>

export type UpdateReservationRuleSectionsMutation = {
  __typename?: "Mutation"
  updateReservationRuleSections?: {
    __typename?: "UpdateReservationRuleSectionsPayload"
    success?: boolean | null
    errors?: Array<{
      __typename?: "UpdateReservationRuleSectionsError"
      code: UpdateReservationRuleSectionsErrorEnum
      message: string
    }> | null
    sections?: Array<{
      __typename?: "ReservationRuleSection"
      id: string
      identifier: string
      title: string
      content?: string | null
      position: number
    }> | null
  } | null
}

export type UpdateVenueMutationVariables = Exact<{
  venueId: Scalars["ID"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  timezone?: InputMaybe<Scalars["String"]["input"]>
  address?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  zipcode?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  website?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  socialAccounts?: InputMaybe<Scalars["JSON"]["input"]>
  venueLogo?: InputMaybe<Scalars["Upload"]["input"]>
  latitude?: InputMaybe<Scalars["Float"]["input"]>
  longitude?: InputMaybe<Scalars["Float"]["input"]>
}>

export type UpdateVenueMutation = {
  __typename?: "Mutation"
  updateVenue?: {
    __typename?: "UpdateVenuePayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UpdateVenueError"; code: UpdateVenueErrorEnum; message: string }> | null
    venue?: {
      __typename?: "Venue"
      id: string
      slug: string
      name: string
      country: string
      timezone: string
      info?: {
        __typename?: "VenueInfo"
        id: string
        address?: string | null
        city?: string | null
        zipcode?: string | null
        phone?: string | null
        email?: string | null
        website?: string | null
        description?: string | null
        socialAccounts?: any | null
        latitude?: number | null
        longitude?: number | null
      } | null
      images: Array<{ __typename?: "Image"; id: string; kind: string; url?: string | null }>
    } | null
  } | null
}

export type UpdateVenueLayoutMutationVariables = Exact<{
  venueId: Scalars["ID"]["input"]
  tableGroups: Array<TableGroupLayoutInput> | TableGroupLayoutInput
  plans?: InputMaybe<Array<VenuePlanInput> | VenuePlanInput>
}>

export type UpdateVenueLayoutMutation = {
  __typename?: "Mutation"
  updateVenueLayout?: {
    __typename?: "UpdateVenueLayoutPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UpdateVenueLayoutError"; code: UpdateVenueLayoutErrorEnum; message: string }> | null
    tableGroups?: Array<{
      __typename?: "TableGroup"
      id: string
      name: string
      deleted: boolean
      tables: Array<{ __typename?: "Table"; id: string; name: string; deleted: boolean }>
    }> | null
  } | null
}

export type UpdateVenueTagsMutationVariables = Exact<{
  venueId: Scalars["ID"]["input"]
  tags: Scalars["JSON"]["input"]
}>

export type UpdateVenueTagsMutation = {
  __typename?: "Mutation"
  updateVenueTags?: {
    __typename?: "UpdateVenueTagsPayload"
    success?: boolean | null
    errors?: Array<{ __typename?: "UpdateVenueTagsError"; code: UpdateVenueTagsErrorEnum; message: string }> | null
    venue?: {
      __typename?: "Venue"
      tags: Array<{
        __typename?: "VenueTag"
        category: string
        value: string
        label: string
        position: number
        custom: boolean
      }>
    } | null
  } | null
}

export type UpdateVenueWorkingHoursMutationVariables = Exact<{
  venueId: Scalars["ID"]["input"]
  workingHours: Array<VenueWorkingHourInput> | VenueWorkingHourInput
}>

export type UpdateVenueWorkingHoursMutation = {
  __typename?: "Mutation"
  updateVenueWorkingHours?: {
    __typename?: "UpdateVenueWorkingHoursPayload"
    success?: boolean | null
    workingHours?: Array<{
      __typename?: "OpeningHour"
      id: string
      kind?: OpeningHourKind | null
      weekday?: number | null
      startDate?: any | null
      endDate?: any | null
      startTime?: string | null
      endTime?: string | null
      closed?: boolean | null
    }> | null
    errors?: Array<{
      __typename?: "UpdateVenueWorkingHoursError"
      code: UpdateVenueWorkingHoursErrorEnum
      message: string
    }> | null
  } | null
}

export const GetAppConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAppConfig" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "appConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "googleMapsApiKey" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppConfigQuery, GetAppConfigQueryVariables>
export const GetCurrentUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCurrentUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>
export const GetCurrentUserRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCurrentUserRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueSlug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "venueSlug" },
                      value: { kind: "Variable", name: { kind: "Name", value: "venueSlug" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "venue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "slug" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>
export const GetCurrentUserWithInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCurrentUserWithInfo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                      { kind: "Field", name: { kind: "Name", value: "postcode" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserWithInfoQuery, GetCurrentUserWithInfoQueryVariables>
export const UpdatePasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "currentPassword" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newPasswordConfirmation" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "currentPassword" },
                value: { kind: "Variable", name: { kind: "Name", value: "currentPassword" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newPassword" },
                value: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newPasswordConfirmation" },
                value: { kind: "Variable", name: { kind: "Name", value: "newPasswordConfirmation" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>
export const CreateCustomerNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createCustomerNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCustomerNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCustomerNoteMutation, CreateCustomerNoteMutationVariables>
export const GetCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "business" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservations" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                                  { kind: "Field", name: { kind: "Name", value: "noShow" } },
                                  { kind: "Field", name: { kind: "Name", value: "pending" } },
                                  { kind: "Field", name: { kind: "Name", value: "seated" } },
                                  { kind: "Field", name: { kind: "Name", value: "total" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerContacts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerQuery, GetCustomerQueryVariables>
export const GetCustomerActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomerActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "business" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "Variable", name: { kind: "Name", value: "last" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "before" },
                            value: { kind: "Variable", name: { kind: "Name", value: "before" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "after" },
                            value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                                  { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                                  { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                                  { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "owner" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "email" } },
                                              { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                                              { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                              { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "parameters" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerActivitiesQuery, GetCustomerActivitiesQueryVariables>
export const GetCustomerByContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomerByContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerContactId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "business" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "customerContactId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customerContactId" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservations" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                                  { kind: "Field", name: { kind: "Name", value: "noShow" } },
                                  { kind: "Field", name: { kind: "Name", value: "pending" } },
                                  { kind: "Field", name: { kind: "Name", value: "seated" } },
                                  { kind: "Field", name: { kind: "Name", value: "total" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerContacts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerByContactQuery, GetCustomerByContactQueryVariables>
export const GetCustomerContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomerContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchField" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "CustomerContactSort" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortDirection" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "business" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerContacts" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "page" },
                      value: { kind: "Variable", name: { kind: "Name", value: "page" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "perPage" },
                      value: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "search" },
                      value: { kind: "Variable", name: { kind: "Name", value: "search" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "searchField" },
                      value: { kind: "Variable", name: { kind: "Name", value: "searchField" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sort" },
                      value: { kind: "Variable", name: { kind: "Name", value: "sort" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortDirection" },
                      value: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadata" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                            { kind: "Field", name: { kind: "Name", value: "limitValue" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                            { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "stats" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "reservations" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "noShow" } },
                                              { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                                              { kind: "Field", name: { kind: "Name", value: "total" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerContactsQuery, GetCustomerContactsQueryVariables>
export const GetCustomerNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomerNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "business" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerNotes" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "customerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "page" },
                      value: { kind: "Variable", name: { kind: "Name", value: "page" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "perPage" },
                      value: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadata" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                            { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerNotesQuery, GetCustomerNotesQueryVariables>
export const GetCustomerReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomerReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "business" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservations" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "page" },
                            value: { kind: "Variable", name: { kind: "Name", value: "page" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "perPage" },
                            value: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                                  { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                                  { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "collection" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "startTime" } },
                                  { kind: "Field", name: { kind: "Name", value: "endTime" } },
                                  { kind: "Field", name: { kind: "Name", value: "peopleAmount" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "customerNote" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "venue" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "table" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "tableGroup" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "id" } },
                                              { kind: "Field", name: { kind: "Name", value: "name" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerReservationsQuery, GetCustomerReservationsQueryVariables>
export const UpdateCustomerContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCustomerContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerContactId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCustomerContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerContactId" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerContactId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerContact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCustomerContactMutation, UpdateCustomerContactMutationVariables>
export const GetFeatureFlagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFeatureFlags" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "featureFlags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "customSectionsEnabled" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>
export const GeocodeAddressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "geocodeAddress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "geocodeAddress" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GeocodeAddressQuery, GeocodeAddressQueryVariables>
export const RemoveImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "imageId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "associatedId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "associatedType" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Associated" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "imageId" },
                value: { kind: "Variable", name: { kind: "Name", value: "imageId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "associatedId" },
                value: { kind: "Variable", name: { kind: "Name", value: "associatedId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "associatedType" },
                value: { kind: "Variable", name: { kind: "Name", value: "associatedType" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveImageMutation, RemoveImageMutationVariables>
export const CompleteOauthSignupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "completeOauthSignup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "businessName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Country" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "completeOauthSignup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessName" },
                value: { kind: "Variable", name: { kind: "Name", value: "businessName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteOauthSignupMutation, CompleteOauthSignupMutationVariables>
export const GetOAuthProvidersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOAuthProviders" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oauthProviders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "googleEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "facebookEnabled" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOAuthProvidersQuery, GetOAuthProvidersQueryVariables>
export const GetOAuthSignupDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOAuthSignupData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oauthSignupData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOAuthSignupDataQuery, GetOAuthSignupDataQueryVariables>
export const CreateAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "businessName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Country" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessName" },
                value: { kind: "Variable", name: { kind: "Name", value: "businessName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: { kind: "Variable", name: { kind: "Name", value: "password" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAccountMutation, CreateAccountMutationVariables>
export const GetPublicBusyBlocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPublicBusyBlocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601Date" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "excludeReservationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "public" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "slug" },
                      value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "busyBlocks" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "tableId" },
                            value: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "date" },
                            value: { kind: "Variable", name: { kind: "Name", value: "date" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "excludeReservationId" },
                            value: { kind: "Variable", name: { kind: "Name", value: "excludeReservationId" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "startTime" } },
                            { kind: "Field", name: { kind: "Name", value: "endTime" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPublicBusyBlocksQuery, GetPublicBusyBlocksQueryVariables>
export const GetPublicReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPublicReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "public" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "locale" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleAmount" } },
                      { kind: "Field", name: { kind: "Name", value: "startTime" } },
                      { kind: "Field", name: { kind: "Name", value: "endTime" } },
                      { kind: "Field", name: { kind: "Name", value: "tableId" } },
                      { kind: "Field", name: { kind: "Name", value: "tableName" } },
                      { kind: "Field", name: { kind: "Name", value: "venueName" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "canCancel" } },
                      { kind: "Field", name: { kind: "Name", value: "canStartCancellation" } },
                      { kind: "Field", name: { kind: "Name", value: "cancellationDeadlineAt" } },
                      { kind: "Field", name: { kind: "Name", value: "customerNote" } },
                      { kind: "Field", name: { kind: "Name", value: "referenceNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "timezone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "venue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "slug" } },
                            { kind: "Field", name: { kind: "Name", value: "timezone" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "kind" },
                                  value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "venue_photo" }] },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                  { kind: "Field", name: { kind: "Name", value: "kind" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "phone" } },
                                  { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "address" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                  { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationConfiguration" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "availableBookingPolicyTiles" } },
                                  { kind: "Field", name: { kind: "Name", value: "bookingPolicyTiles" } },
                                  { kind: "Field", name: { kind: "Name", value: "cancellationDeadline" } },
                                  { kind: "Field", name: { kind: "Name", value: "largeGroupThreshold" } },
                                  { kind: "Field", name: { kind: "Name", value: "maxReservationTime" } },
                                  { kind: "Field", name: { kind: "Name", value: "minReservationTime" } },
                                  { kind: "Field", name: { kind: "Name", value: "noshowAutoCancelAfter" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationRuleSections" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "identifier" } },
                                  { kind: "Field", name: { kind: "Name", value: "position" } },
                                  { kind: "Field", name: { kind: "Name", value: "title" } },
                                  { kind: "Field", name: { kind: "Name", value: "content" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tableGroups" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPublicReservationQuery, GetPublicReservationQueryVariables>
export const GetPublicTableBusyBlocksByDateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPublicTableBusyBlocksByDate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601Date" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "public" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "slug" },
                      value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableBusyBlocksByDate" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "date" },
                            value: { kind: "Variable", name: { kind: "Name", value: "date" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "tableId" } },
                            { kind: "Field", name: { kind: "Name", value: "startTime" } },
                            { kind: "Field", name: { kind: "Name", value: "endTime" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPublicTableBusyBlocksByDateQuery, GetPublicTableBusyBlocksByDateQueryVariables>
export const PublicVenueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "publicVenue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "public" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "slug" },
                      value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "defaultLocale" } },
                      { kind: "Field", name: { kind: "Name", value: "timezone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "website" } },
                            { kind: "Field", name: { kind: "Name", value: "socialAccounts" } },
                            { kind: "Field", name: { kind: "Name", value: "latitude" } },
                            { kind: "Field", name: { kind: "Name", value: "longitude" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "kind" },
                            value: {
                              kind: "ListValue",
                              values: [
                                { kind: "EnumValue", value: "venue_photo" },
                                { kind: "EnumValue", value: "venue_logo" },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "kind" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingHours" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "closed" } },
                            { kind: "Field", name: { kind: "Name", value: "endDate" } },
                            { kind: "Field", name: { kind: "Name", value: "endTime" } },
                            { kind: "Field", name: { kind: "Name", value: "kind" } },
                            { kind: "Field", name: { kind: "Name", value: "startDate" } },
                            { kind: "Field", name: { kind: "Name", value: "startTime" } },
                            { kind: "Field", name: { kind: "Name", value: "weekday" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationConfiguration" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "availableBookingPolicyTiles" } },
                            { kind: "Field", name: { kind: "Name", value: "bookingPolicyTiles" } },
                            { kind: "Field", name: { kind: "Name", value: "maxAdvanceBookingTime" } },
                            { kind: "Field", name: { kind: "Name", value: "minAdvanceBookingTime" } },
                            { kind: "Field", name: { kind: "Name", value: "minReservationTime" } },
                            { kind: "Field", name: { kind: "Name", value: "maxReservationTime" } },
                            { kind: "Field", name: { kind: "Name", value: "reservationBuffer" } },
                            { kind: "Field", name: { kind: "Name", value: "noshowAutoCancelAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "cancellationDeadline" } },
                            { kind: "Field", name: { kind: "Name", value: "largeGroupThreshold" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationRuleSections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "identifier" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "content" } },
                            { kind: "Field", name: { kind: "Name", value: "position" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tables" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "minCapacity" } },
                            { kind: "Field", name: { kind: "Name", value: "maxCapacity" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tableGroup" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plans" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "sectionName" } },
                            { kind: "Field", name: { kind: "Name", value: "plan" } },
                            { kind: "Field", name: { kind: "Name", value: "position" } },
                            { kind: "Field", name: { kind: "Name", value: "default" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "position" } },
                            { kind: "Field", name: { kind: "Name", value: "custom" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicVenueQuery, PublicVenueQueryVariables>
export const IsVenueOpenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsVenueOpen" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "public" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "slug" },
                      value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "open" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "startTime" },
                            value: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "endTime" },
                            value: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsVenueOpenQuery, IsVenueOpenQueryVariables>
export const PublicCancelReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "publicCancelReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicCancelReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "canCancel" } },
                      { kind: "Field", name: { kind: "Name", value: "canStartCancellation" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicCancelReservationMutation, PublicCancelReservationMutationVariables>
export const PublicConfirmReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "publicConfirmReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicConfirmReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicConfirmReservationMutation, PublicConfirmReservationMutationVariables>
export const PublicCreateReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "publicCreateReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venue" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PublicCustomerInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locale" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicCreateReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venue" },
                value: { kind: "Variable", name: { kind: "Name", value: "venue" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customer" },
                value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: { kind: "Variable", name: { kind: "Name", value: "locale" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "peopleAmount" },
                value: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tableId" },
                value: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "confirmUntil" } },
                { kind: "Field", name: { kind: "Name", value: "resendAvailableAt" } },
                { kind: "Field", name: { kind: "Name", value: "resendsRemaining" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicCreateReservationMutation, PublicCreateReservationMutationVariables>
export const PublicModifyReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "publicModifyReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "originalReservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venue" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PublicCustomerInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locale" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicModifyReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "originalReservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "originalReservationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "venue" },
                value: { kind: "Variable", name: { kind: "Name", value: "venue" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customer" },
                value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: { kind: "Variable", name: { kind: "Name", value: "locale" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "peopleAmount" },
                value: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tableId" },
                value: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "confirmUntil" } },
                { kind: "Field", name: { kind: "Name", value: "resendAvailableAt" } },
                { kind: "Field", name: { kind: "Name", value: "resendsRemaining" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicModifyReservationMutation, PublicModifyReservationMutationVariables>
export const PublicResendReservationConfirmationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "publicResendReservationConfirmation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicResendReservationConfirmation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "confirmUntil" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "confirmUntil" } },
                { kind: "Field", name: { kind: "Name", value: "resendAvailableAt" } },
                { kind: "Field", name: { kind: "Name", value: "resendsRemaining" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublicResendReservationConfirmationMutation,
  PublicResendReservationConfirmationMutationVariables
>
export const RequestPasswordResetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestPasswordReset" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicRequestPasswordReset" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>
export const CreateReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CustomerInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableSlots" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "TableSlotInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notes" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ReservationNoteInput" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customer" },
                value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "peopleAmount" },
                value: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tableSlots" },
                value: { kind: "Variable", name: { kind: "Name", value: "tableSlots" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notes" },
                value: { kind: "Variable", name: { kind: "Name", value: "notes" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "startTime" } },
                      { kind: "Field", name: { kind: "Name", value: "endTime" } },
                      { kind: "Field", name: { kind: "Name", value: "peopleAmount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "table" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "venue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customerContacts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "phone" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "customerNote" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReservationMutation, CreateReservationMutationVariables>
export const CreateReservationNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createReservationNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createReservationNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: { kind: "Variable", name: { kind: "Name", value: "note" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReservationNoteMutation, CreateReservationNoteMutationVariables>
export const GetReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
                { kind: "Field", name: { kind: "Name", value: "peopleAmount" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "table" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservations" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "pending" } },
                                  { kind: "Field", name: { kind: "Name", value: "seated" } },
                                  { kind: "Field", name: { kind: "Name", value: "noShow" } },
                                  { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                                  { kind: "Field", name: { kind: "Name", value: "total" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerContact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "customerNote" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plans" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "sectionName" } },
                      { kind: "Field", name: { kind: "Name", value: "plan" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                      { kind: "Field", name: { kind: "Name", value: "default" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "reservationBuffer" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReservationQuery, GetReservationQueryVariables>
export const GetReservationActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getReservationActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activities" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "last" },
                      value: { kind: "Variable", name: { kind: "Name", value: "last" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "before" },
                      value: { kind: "Variable", name: { kind: "Name", value: "before" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "owner" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "email" } },
                                        { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                            { kind: "Field", name: { kind: "Name", value: "parameters" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReservationActivitiesQuery, GetReservationActivitiesQueryVariables>
export const GetReservationNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getReservationNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notes" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "last" },
                      value: { kind: "Variable", name: { kind: "Name", value: "last" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "before" },
                      value: { kind: "Variable", name: { kind: "Name", value: "before" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReservationNotesQuery, GetReservationNotesQueryVariables>
export const GetReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFilter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ReservationDateFilterInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ReservationStatus" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeRemoved" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableGroups" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservations" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateFilter" },
                      value: { kind: "Variable", name: { kind: "Name", value: "dateFilter" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeRemoved" },
                      value: { kind: "Variable", name: { kind: "Name", value: "includeRemoved" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "tableGroups" },
                      value: { kind: "Variable", name: { kind: "Name", value: "tableGroups" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "1000" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "startTime" } },
                            { kind: "Field", name: { kind: "Name", value: "endTime" } },
                            { kind: "Field", name: { kind: "Name", value: "peopleAmount" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "table" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "deleted" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tableGroup" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customerContact" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "phone" } },
                                  { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "customerNote" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReservationsQuery, GetReservationsQueryVariables>
export const RemoveReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveReservationMutation, RemoveReservationMutationVariables>
export const UpdateReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ISO8601DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ReservationStatus" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerPhone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerContactId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "updateAllContacts" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tableId" },
                value: { kind: "Variable", name: { kind: "Name", value: "tableId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "peopleAmount" },
                value: { kind: "Variable", name: { kind: "Name", value: "peopleAmount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerName" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerEmail" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerEmail" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerPhone" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerPhone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerContactId" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerContactId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateAllContacts" },
                value: { kind: "Variable", name: { kind: "Name", value: "updateAllContacts" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateReservationMutation, UpdateReservationMutationVariables>
export const ResetPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resetPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "passwordConfirmation" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicResetPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: { kind: "Variable", name: { kind: "Name", value: "password" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordConfirmation" },
                value: { kind: "Variable", name: { kind: "Name", value: "passwordConfirmation" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>
export const UploadImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "uploadImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "image" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Upload" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "kind" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ImageKind" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "associatedId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "associatedType" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Associated" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "image" },
                value: { kind: "Variable", name: { kind: "Name", value: "image" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "kind" },
                value: { kind: "Variable", name: { kind: "Name", value: "kind" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "associatedId" },
                value: { kind: "Variable", name: { kind: "Name", value: "associatedId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "associatedType" },
                value: { kind: "Variable", name: { kind: "Name", value: "associatedType" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadImageMutation, UploadImageMutationVariables>
export const CreateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "passwordConfirmation" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "city" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "position" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "postcode" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roles" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserRoleInput" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: { kind: "Variable", name: { kind: "Name", value: "password" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordConfirmation" },
                value: { kind: "Variable", name: { kind: "Name", value: "passwordConfirmation" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "city" },
                value: { kind: "Variable", name: { kind: "Name", value: "city" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "position" },
                value: { kind: "Variable", name: { kind: "Name", value: "position" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "postcode" },
                value: { kind: "Variable", name: { kind: "Name", value: "postcode" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: { kind: "Variable", name: { kind: "Name", value: "roles" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>
export const DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "deletedUserId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>
export const GetUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserSortField" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortDirection" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortDirection" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: { kind: "Variable", name: { kind: "Name", value: "page" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "perPage" },
                value: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                      { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      { kind: "Field", name: { kind: "Name", value: "limitValue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "avatar" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "position" } },
                            { kind: "Field", name: { kind: "Name", value: "postcode" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "venue" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "slug" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>
export const UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "city" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "position" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "postcode" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "avatar" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Upload" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "removeAvatar" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roles" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserRoleInput" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "city" },
                value: { kind: "Variable", name: { kind: "Name", value: "city" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "position" },
                value: { kind: "Variable", name: { kind: "Name", value: "position" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "postcode" },
                value: { kind: "Variable", name: { kind: "Name", value: "postcode" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "avatar" },
                value: { kind: "Variable", name: { kind: "Name", value: "avatar" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "removeAvatar" },
                value: { kind: "Variable", name: { kind: "Name", value: "removeAvatar" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: { kind: "Variable", name: { kind: "Name", value: "roles" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "avatar" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>
export const UpdateUserInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "city" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "position" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "postcode" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "avatar" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Upload" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "removeAvatar" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: { kind: "Variable", name: { kind: "Name", value: "firstName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: { kind: "Variable", name: { kind: "Name", value: "lastName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "city" },
                value: { kind: "Variable", name: { kind: "Name", value: "city" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "position" },
                value: { kind: "Variable", name: { kind: "Name", value: "position" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "postcode" },
                value: { kind: "Variable", name: { kind: "Name", value: "postcode" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "avatar" },
                value: { kind: "Variable", name: { kind: "Name", value: "avatar" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "removeAvatar" },
                value: { kind: "Variable", name: { kind: "Name", value: "removeAvatar" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "phoneFormatted" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                      { kind: "Field", name: { kind: "Name", value: "postcode" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "avatar" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>
export const CountFutureReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countFutureReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableIds" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableGroupIds" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFilter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ReservationDateFilterInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservations" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateFilter" },
                      value: { kind: "Variable", name: { kind: "Name", value: "dateFilter" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "pending" },
                          { kind: "EnumValue", value: "confirmed" },
                          { kind: "EnumValue", value: "seated" },
                          { kind: "EnumValue", value: "walk_in" },
                        ],
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "tables" },
                      value: { kind: "Variable", name: { kind: "Name", value: "tableIds" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "tableGroups" },
                      value: { kind: "Variable", name: { kind: "Name", value: "tableGroupIds" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountFutureReservationsQuery, CountFutureReservationsQueryVariables>
export const CreateVenueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createVenue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createVenue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "timezone" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVenueMutation, CreateVenueMutationVariables>
export const GetOpeningHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOpeningHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "openingHours" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "closed" } },
                      { kind: "Field", name: { kind: "Name", value: "endDate" } },
                      { kind: "Field", name: { kind: "Name", value: "endTime" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "startTime" } },
                      { kind: "Field", name: { kind: "Name", value: "weekday" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "manageVenue" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOpeningHoursQuery, GetOpeningHoursQueryVariables>
export const GetTagDefinitionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTagDefinitions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tagDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "selectionType" } },
                { kind: "Field", name: { kind: "Name", value: "maxSelections" } },
                { kind: "Field", name: { kind: "Name", value: "allowCustom" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "descriptionText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTagDefinitionsQuery, GetTagDefinitionsQueryVariables>
export const GetVenueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVenue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeDeleted" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tableGroups" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDeleted" },
                      value: { kind: "Variable", name: { kind: "Name", value: "includeDeleted" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tables" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "includeDeleted" },
                            value: { kind: "Variable", name: { kind: "Name", value: "includeDeleted" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "deleted" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tables" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDeleted" },
                      value: { kind: "Variable", name: { kind: "Name", value: "includeDeleted" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "minReservationTime" } },
                      { kind: "Field", name: { kind: "Name", value: "maxReservationTime" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "kind" },
                      value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "venue_logo" }] },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "viewReservations" } },
                      { kind: "Field", name: { kind: "Name", value: "manageReservations" } },
                      { kind: "Field", name: { kind: "Name", value: "viewActivityLog" } },
                      { kind: "Field", name: { kind: "Name", value: "viewClients" } },
                      { kind: "Field", name: { kind: "Name", value: "manageVenue" } },
                      { kind: "Field", name: { kind: "Name", value: "viewReports" } },
                      { kind: "Field", name: { kind: "Name", value: "createVenues" } },
                      { kind: "Field", name: { kind: "Name", value: "manageUsers" } },
                      { kind: "Field", name: { kind: "Name", value: "billing" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "venues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "viewReservations" } },
                      { kind: "Field", name: { kind: "Name", value: "manageReservations" } },
                      { kind: "Field", name: { kind: "Name", value: "viewActivityLog" } },
                      { kind: "Field", name: { kind: "Name", value: "viewClients" } },
                      { kind: "Field", name: { kind: "Name", value: "manageVenue" } },
                      { kind: "Field", name: { kind: "Name", value: "viewReports" } },
                      { kind: "Field", name: { kind: "Name", value: "createVenues" } },
                      { kind: "Field", name: { kind: "Name", value: "manageUsers" } },
                      { kind: "Field", name: { kind: "Name", value: "billing" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVenueQuery, GetVenueQueryVariables>
export const GetVenueActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVenueActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeRelated" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activities" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "page" },
                      value: { kind: "Variable", name: { kind: "Name", value: "page" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "perPage" },
                      value: { kind: "Variable", name: { kind: "Name", value: "perPage" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeRelated" },
                      value: { kind: "Variable", name: { kind: "Name", value: "includeRelated" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadata" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                            { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                            { kind: "Field", name: { kind: "Name", value: "parameters" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "owner" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                        { kind: "Field", name: { kind: "Name", value: "avatarUrl" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resource" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Reservation" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Venue" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "slug" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "customerContacts" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "id" } },
                                              { kind: "Field", name: { kind: "Name", value: "name" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVenueActivitiesQuery, GetVenueActivitiesQueryVariables>
export const GetVenueFullDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVenueFull" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tableGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "minCapacity" } },
                      { kind: "Field", name: { kind: "Name", value: "maxCapacity" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "deleted" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plans" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "sectionName" } },
                      { kind: "Field", name: { kind: "Name", value: "plan" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                      { kind: "Field", name: { kind: "Name", value: "default" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "website" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "socialAccounts" } },
                      { kind: "Field", name: { kind: "Name", value: "latitude" } },
                      { kind: "Field", name: { kind: "Name", value: "longitude" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "manageVenue" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "reservationBuffer" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationRuleSections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "identifier" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                      { kind: "Field", name: { kind: "Name", value: "custom" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "venues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVenueFullQuery, GetVenueFullQueryVariables>
export const GetVenueInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVenueInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "website" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "socialAccounts" } },
                      { kind: "Field", name: { kind: "Name", value: "latitude" } },
                      { kind: "Field", name: { kind: "Name", value: "longitude" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVenueInfoQuery, GetVenueInfoQueryVariables>
export const GetVenueReservationConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetVenueReservationConfiguration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "availableBookingPolicyTiles" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingPolicyTiles" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "minAdvanceBookingTime" } },
                      { kind: "Field", name: { kind: "Name", value: "maxAdvanceBookingTime" } },
                      { kind: "Field", name: { kind: "Name", value: "minReservationTime" } },
                      { kind: "Field", name: { kind: "Name", value: "maxReservationTime" } },
                      { kind: "Field", name: { kind: "Name", value: "reservationBuffer" } },
                      { kind: "Field", name: { kind: "Name", value: "noshowAutoCancelAfter" } },
                      { kind: "Field", name: { kind: "Name", value: "cancellationDeadline" } },
                      { kind: "Field", name: { kind: "Name", value: "largeGroupThreshold" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tableGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationRuleSections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "identifier" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "manageVenue" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVenueReservationConfigurationQuery, GetVenueReservationConfigurationQueryVariables>
export const GetVenuesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVenues" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "venues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "viewReservations" } },
                      { kind: "Field", name: { kind: "Name", value: "manageReservations" } },
                      { kind: "Field", name: { kind: "Name", value: "viewActivityLog" } },
                      { kind: "Field", name: { kind: "Name", value: "viewClients" } },
                      { kind: "Field", name: { kind: "Name", value: "manageVenue" } },
                      { kind: "Field", name: { kind: "Name", value: "viewReports" } },
                      { kind: "Field", name: { kind: "Name", value: "createVenues" } },
                      { kind: "Field", name: { kind: "Name", value: "manageUsers" } },
                      { kind: "Field", name: { kind: "Name", value: "billing" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVenuesQuery, GetVenuesQueryVariables>
export const UpdateReservationConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateReservationConfiguration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "minAdvanceBookingTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxAdvanceBookingTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "minReservationTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxReservationTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reservationBuffer" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "noshowAutoCancelAfter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cancellationDeadline" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "largeGroupThreshold" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bookingPolicyTiles" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "BookingPolicyTile" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateReservationConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "minAdvanceBookingTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "minAdvanceBookingTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxAdvanceBookingTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxAdvanceBookingTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "minReservationTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "minReservationTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxReservationTime" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxReservationTime" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationBuffer" },
                value: { kind: "Variable", name: { kind: "Name", value: "reservationBuffer" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "noshowAutoCancelAfter" },
                value: { kind: "Variable", name: { kind: "Name", value: "noshowAutoCancelAfter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cancellationDeadline" },
                value: { kind: "Variable", name: { kind: "Name", value: "cancellationDeadline" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "largeGroupThreshold" },
                value: { kind: "Variable", name: { kind: "Name", value: "largeGroupThreshold" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingPolicyTiles" },
                value: { kind: "Variable", name: { kind: "Name", value: "bookingPolicyTiles" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "availableBookingPolicyTiles" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingPolicyTiles" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "minAdvanceBookingTime" } },
                      { kind: "Field", name: { kind: "Name", value: "maxAdvanceBookingTime" } },
                      { kind: "Field", name: { kind: "Name", value: "minReservationTime" } },
                      { kind: "Field", name: { kind: "Name", value: "maxReservationTime" } },
                      { kind: "Field", name: { kind: "Name", value: "reservationBuffer" } },
                      { kind: "Field", name: { kind: "Name", value: "noshowAutoCancelAfter" } },
                      { kind: "Field", name: { kind: "Name", value: "cancellationDeadline" } },
                      { kind: "Field", name: { kind: "Name", value: "largeGroupThreshold" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateReservationConfigurationMutation, UpdateReservationConfigurationMutationVariables>
export const UpdateReservationRuleSectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateReservationRuleSections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sections" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "ReservationRuleSectionInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateReservationRuleSections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sections" },
                value: { kind: "Variable", name: { kind: "Name", value: "sections" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "identifier" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "position" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateReservationRuleSectionsMutation, UpdateReservationRuleSectionsMutationVariables>
export const UpdateVenueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateVenue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "country" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "city" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "zipcode" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phone" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "website" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "socialAccounts" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueLogo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Upload" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "latitude" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "longitude" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateVenue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: { kind: "Variable", name: { kind: "Name", value: "country" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: { kind: "Variable", name: { kind: "Name", value: "timezone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "city" },
                value: { kind: "Variable", name: { kind: "Name", value: "city" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "zipcode" },
                value: { kind: "Variable", name: { kind: "Name", value: "zipcode" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: { kind: "Variable", name: { kind: "Name", value: "phone" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "website" },
                value: { kind: "Variable", name: { kind: "Name", value: "website" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "socialAccounts" },
                value: { kind: "Variable", name: { kind: "Name", value: "socialAccounts" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueLogo" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueLogo" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "latitude" },
                value: { kind: "Variable", name: { kind: "Name", value: "latitude" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "longitude" },
                value: { kind: "Variable", name: { kind: "Name", value: "longitude" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "timezone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "website" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "socialAccounts" } },
                            { kind: "Field", name: { kind: "Name", value: "latitude" } },
                            { kind: "Field", name: { kind: "Name", value: "longitude" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "kind" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVenueMutation, UpdateVenueMutationVariables>
export const UpdateVenueLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateVenueLayout" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tableGroups" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "TableGroupLayoutInput" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "plans" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "VenuePlanInput" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateVenueLayout" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tableGroups" },
                value: { kind: "Variable", name: { kind: "Name", value: "tableGroups" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plans" },
                value: { kind: "Variable", name: { kind: "Name", value: "plans" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tableGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tables" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "deleted" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVenueLayoutMutation, UpdateVenueLayoutMutationVariables>
export const UpdateVenueTagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateVenueTags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tags" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateVenueTags" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tags" },
                value: { kind: "Variable", name: { kind: "Name", value: "tags" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "venue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "position" } },
                            { kind: "Field", name: { kind: "Name", value: "custom" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVenueTagsMutation, UpdateVenueTagsMutationVariables>
export const UpdateVenueWorkingHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateVenueWorkingHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "workingHours" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "VenueWorkingHourInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateVenueWorkingHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "venueId" },
                value: { kind: "Variable", name: { kind: "Name", value: "venueId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "workingHours" },
                value: { kind: "Variable", name: { kind: "Name", value: "workingHours" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workingHours" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "weekday" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "endDate" } },
                      { kind: "Field", name: { kind: "Name", value: "startTime" } },
                      { kind: "Field", name: { kind: "Name", value: "endTime" } },
                      { kind: "Field", name: { kind: "Name", value: "closed" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVenueWorkingHoursMutation, UpdateVenueWorkingHoursMutationVariables>
